<template>
    <v-container>
        <v-snackbar v-model="alert" timeout="5000" :color="alertType">
            {{ alertContent }}
        </v-snackbar>
        <v-card style="margin-bottom:10px">
            <v-card-title>
                {{ $t('extnetions') }}
                <v-spacer></v-spacer>
                <div v-show="selectedFiles.length">
                    <v-btn icon @click="multiCutAlert = true">
                        <v-icon>mdi-content-cut</v-icon>
                    </v-btn>
                    <v-btn icon @click="multiCopyAlert = true">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn icon @click="multiDownload">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn icon @click="multiDelete">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
                <v-dialog v-model="newExt" width="800">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon large>
                            <v-icon>mdi-folder-plus</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title primary-title>
                            {{ $t('createNewExt') }}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field :label="$t('extNumber')" type="text" v-model="newFolderName"></v-text-field>
                            <v-radio-group v-model="newExtFromType" @change="extFrom">
                                <v-radio :label="$t('selectExtTypeFromList')" value="fromlist"></v-radio>
                                <v-radio :label="$t('typingExtType')" value="fromType"></v-radio>
                            </v-radio-group>
                            <v-autocomplete v-model="newFolderType" v-show="fromList" :label="$t('extType')"
                                :items="selectExtTypes" item-text="title" item-value="value"></v-autocomplete>
                            <v-text-field v-model="newFolderType" v-show="fromType" :label="$t('pleaseTypeExtType')"
                                :hint="$t('typeExtTypeNote')"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="createFolder">{{ $t('createExt') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="uploadFiles" width="800">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon large>
                            <v-icon>mdi-cloud-upload</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title primary-title>
                            {{ $t('uploadFiles') }}
                        </v-card-title>
                        <v-card-text>
                            <v-tabs fixed-tabs>
                                <v-tab>
                                    <v-icon right>mdi-pencil-box</v-icon>
                                    {{ $t('uploadIniFile') }}
                                </v-tab>
                                <v-tab>
                                    <v-icon right>mdi-account-voice</v-icon>
                                    {{ $t('uploadTtsFile') }}
                                </v-tab>
                                <v-tab>
                                    <v-icon right>mdi-cloud-upload</v-icon>
                                    {{ $t('uploadFiles') }}
                                </v-tab>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-title primary-title>
                                            {{ $t('uploadIniFile') }} <v-spacer></v-spacer>
                                            <v-subheader><a href="https://f2.freeivr.co.il/" target="_blank">{{
                                                $t('goToForum')
                                            }}</a></v-subheader>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="newIniFileName" :label="$t('fileName')"
                                                        :hint="$t('newFileNote')"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field :value="`${newIniFileName}.ini`" readonly></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-textarea v-model="newIniFileContent" label="תוכן הקובץ" solo-inverted
                                                rows="10" dir="ltr"></v-textarea>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" style="margin-top:-30px;" @click="uploadINI">{{
                                                $t('uploadTheFile')
                                            }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-title primary-title>
                                            {{ $t('uploadTtsFile') }}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="newTtsFileName" :label="$t('fileName')"
                                                        :hint="$t('newFileNote')"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field :value="`${newTtsFileName}.tts`" readonly></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-textarea v-model="newTtsFileContent" :label="$t('textToRead')" solo-inverted
                                                rows="10"></v-textarea>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" style="margin-top:-30px;" @click="uploadTTS">{{
                                                $t('uploadTheFile')
                                            }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card>
                                        <v-card-title primary-title>
                                            {{ $t('uploadFiles') }}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-file-input v-model="file" clearable :label="$t('uploadSelectFile')"
                                                accept="audio/*"></v-file-input>
                                            <p v-show="uploadStatus" style="margin-bottom: 0px; margin-right: 92%">{{
                                                uploadProgress
                                            }}%</p>
                                            <v-progress-linear v-show="uploadStatus" color="primary"
                                                :value="uploadProgress"></v-progress-linear>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" @click="uploadFile">{{ $t('uploadTheFile') }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </v-card>
        <v-alert color="primary" text v-show="copyAlert">
            <v-row align="center">
                <v-col class="grow">
                    {{ $t('copyFile') }} {{ pathToCopy }}, {{ $t('pleaseSelectTargetFolder') }}.
                </v-col>
                <v-col class="shrink">
                    <v-btn color="primary" outlined @click="pasteCopy">{{ $t('pasteHere') }}</v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-alert color="primary" text v-show="moveAlert">
            <v-row align="center">
                <v-col class="grow">
                    {{ $t('moveFile') }} {{ pathToMove }}, {{ $t('pleaseSelectTargetFolder') }}.
                </v-col>
                <v-col class="shrink">
                    <v-btn color="primary" outlined @click="pasteMove">{{ $t('moveHere') }}</v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-alert color="primary" text v-show="multiCutAlert">
            <v-row align="center">
                <v-col class="grow">
                    העברת קבצים מרובים, {{ $t('pleaseSelectTargetFolder') }}.
                </v-col>
                <v-col class="shrink">
                    <v-btn color="primary" outlined @click="multiCut">{{ $t('moveHere') }}</v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-alert color="primary" text v-show="multiCopyAlert">
            <v-row align="center">
                <v-col class="grow">
                    העתקת קבצים מרובים, {{ $t('pleaseSelectTargetFolder') }}.
                </v-col>
                <v-col class="shrink">
                    <v-btn color="primary" outlined @click="multiCopy">{{ $t('moveHere') }}</v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-sheet color="white" elevation="2" class="mb-2 text-center pa-2" rounded width="100%">
            <v-icon @click="$router.go(-1)" :class="$i18n.locale == 'en' ? 'mr-2' : 'ml-2'">{{ $i18n.locale == 'en' ?
                'mdi-chevron-left' : 'mdi-chevron-right'
            }}</v-icon>
            <v-chip v-for="breadcrumb in location" :key="breadcrumb" small :class="$i18n.locale == 'en' ? 'ml-1' : 'mr-1'"
                @click="goToExt(location.indexOf(breadcrumb))">
                {{ breadcrumb }}
            </v-chip>
            <v-icon @click="$router.go(1)" :class="$i18n.locale == 'en' ? 'ml-2' : 'mr-2'">{{ $i18n.locale == 'en' ?
                'mdi-chevron-right' : 'mdi-chevron-left'
            }}</v-icon>
        </v-sheet>
        <v-sheet color="white" elevation="2" class="mb-2 pa-2 text-center" rounded width="100%">
            <v-btn color="primary" text :outlined="showSettings" small
                @click="showStatistics = false, showSettings = true, showMsg = false, showFiles = false">{{
                    $t('settingInExt')
                }}</v-btn>
            <v-btn color="primary" text :outlined="showFiles" small
                @click="showStatistics = false, showMsg = false, showFiles = true, showSettings = false">{{
                    $t('filesInExt')
                }}</v-btn>
            <v-btn color="primary" text :outlined="showMsg" small
                @click="showStatistics = false, showMsg = true, showFiles = false, showSettings = false" class="mr-1">{{
                    $t('systemMessagesInExt')
                }}</v-btn>
            <v-btn color="primary" text :outlined="showStatistics" small
                @click="showStatistics = true, showMsg = false, showFiles = false, showSettings = false" class="mr-1">{{
                    $t('statistics')
                }}</v-btn>
        </v-sheet>
        <v-card v-show="showSettings">
            <v-card-title>
                הגדרות בשלוחה
            </v-card-title>
            <v-card-text>
                <!-- <h2 class="mb-3"><b>סוג השלוחה</b>: {{ settings["type"] }}.</h2> -->
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            הגדרות גלובליות
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-for="setting of settingsData.all" :key="setting.key">
                                <b>{{ setting.title }}</b>: {{ setting.full ? settings[setting.key] || 'לא מוגדר' :
                                    settings[setting.key] ? 'מוגדר' : 'לא מוגדר'
                                }}.<br>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            הגדרות {{ settings["type"] }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-for="setting of settingsData.custom" :key="setting.key">
                                <b>{{ setting.title }}</b>: {{ setting.full ? settings[setting.key] || 'לא מוגדר' :
                                    settings[setting.key] ? 'מוגדר' : 'לא מוגדר'
                                }}.<br>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
        </v-card>
        <v-data-table show-select v-model="selectedFiles" v-show="showFiles" :headers="headers" :items="items"
            item-key="uniqueId" @click:row="redirect" @contextmenu:row="show" oncontextmenu="return false;"
            :items-per-page="-1" class="elevation-1">
            <template v-slot:[`item.icon`]="{ item }">
                <v-avatar color="grey" size="32">
                    <v-icon dark small>{{ item.icon }}</v-icon>
                </v-avatar>
            </template>
            <template v-slot:[`item.what`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>{{ item.what }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon @click.stop="move(item)" small>
                    <v-icon small>mdi-content-cut</v-icon>
                </v-btn>
                <v-btn icon @click.stop="copy(item)" small>
                    <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon @click.stop="raname(item)" small>
                    <v-icon small>mdi-form-textbox</v-icon>
                </v-btn>
                <v-btn v-show="item.fileType !== 'שלוחה' && item.fileType !== 'תיקייה'" icon @click.stop="download(item)"
                    small>
                    <v-icon small>mdi-download</v-icon>
                </v-btn>
                <v-btn icon @click.stop="deleteItem(item)" small>
                    <v-icon small>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
            <v-list>
                <v-list-item @click="move(itemToAction)">
                    <v-list-item-title><v-icon>mdi-content-cut</v-icon></v-list-item-title>
                </v-list-item>
                <v-list-item @click="copy(itemToAction)">
                    <v-list-item-title><v-icon>mdi-content-copy</v-icon></v-list-item-title>
                </v-list-item>
                <v-list-item @click="raname(itemToAction)">
                    <v-list-item-title><v-icon>mdi-form-textbox</v-icon></v-list-item-title>
                </v-list-item>
                <v-list-item v-show="itemToAction.fileType !== $t('extnetion') && itemToAction.fileType !== $t('folder')"
                    @click="download(itemToAction)">
                    <v-list-item-title><v-icon>mdi-download</v-icon></v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteItem(itemToAction)">
                    <v-list-item-title><v-icon>mdi-delete</v-icon></v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-dialog v-model="ranameDialog" width="300">
            <v-card>
                <v-card-title primary-title>
                    {{ $t('raname') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="ranameOld" :label="$t('currentName')" readonly></v-text-field>
                    <v-text-field v-model="ranameNew" :label="$t('newName')"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" style="margin-top:-30px;" @click="ranameSave">{{ $t('raname') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewFile" width="800">
            <v-card>
                <v-card-title primary-title>
                    {{ $t('viewInFile') }}
                </v-card-title>
                <v-card-text>
                    <!-- <codemirror v-model="fileTextContent" :options="cmOptions"></codemirror> -->
                    <v-textarea ref="codeEditor" @input="onCodeInput" @keydown.tab.prevent="onTabKeyDown"
                        v-model="fileTextContent" :label="$t('fileContent')" :readonly="fileEdit" solo-inverted rows="10"
                        dir="ltr"></v-textarea>
                    <div class="suggestions" v-if="showSuggestions">
                        <ul>
                            <li v-for="suggestion in suggestions" :key="suggestion.key"
                                @click="onSuggestionClick(suggestion)">
                                <b>{{ suggestion.key }}</b> | {{ suggestion.description }}
                            </li>
                        </ul>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="fileEdit" color="primary" style="margin-top:-30px;" @click="saveChanges">{{
                        $t('saveChanges')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="audioPlayer" width="800" @close="stopAudio()">
            <v-card>
                <v-card-title primary-title>
                    {{ $t('listenToAudioFile') }} {{ nowPlaying }}
                </v-card-title>
                <v-card-text>
                    <audio id="audio" controls autoplay preload="auto" :src="audioPath" style="width:100%"></audio>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-data-table v-show="showMsg" :headers="msgHeaders" :items="messages" item-key="uniqueId" :items-per-page="-1"
            class="elevation-1">
            <template v-slot:[`item.message`]="{ item }">
                <v-tooltip bottom max-width="75%">
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.message }}</span>
                    </template>
                    <span>{{ item.fullMessage || item.message }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon @click="uploadMsg(item)">
                    <v-icon>mdi-upload</v-icon>
                </v-btn>
                <v-btn :disabled="item.durationStr == null" icon @click="deleteItem(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
        <v-dialog v-model="uploadMsgDialog" width="500">
            <v-card>
                <v-card-title primary-title>
                    {{ $t('uploadSystemMessage') }} {{ messageToUpload }}
                </v-card-title>
                <v-card-text>
                    <v-subheader>{{ messageBodyToUpload }}</v-subheader>
                    <v-file-input v-model="msgFile" clearable :label="$t('uploadSelectFile')"
                        accept="audio/*"></v-file-input>
                    <p v-show="uploadStatus" style="margin-bottom: 0px; margin-right: 92%">{{ uploadProgress }}%</p>
                    <v-progress-linear v-show="uploadStatus" color="primary" :value="uploadProgress"></v-progress-linear>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="uploadMsgFile">{{ $t('uploadTheMessage') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card v-show="showStatistics">
            <v-card-title>
                {{ $t('statistics') }}
            </v-card-title>
            <v-card-text>
                {{ $t('totalCallsInExt') }}: {{ totalEntersCount }}.
            </v-card-text>
        </v-card>
        <download-csv :data="csvFile"
            :name="`ייצוא רשימת צינתוקים ${this.$route.query.list} מתאריך ${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}.csv`">
            <v-btn color="primary" outlined style="display: none" id="download-csv">
                <v-icon small left>mdi-download</v-icon> הורד טבלה למחשב
            </v-btn>
        </download-csv>
    </v-container>
</template>
<script>
import axios from 'axios';

export default {
    data: () => ({
        alert: false,
        alertType: '',
        alertContent: '',
        ivrFileList: '',
        uploadFiles: false,
        newExt: false,
        fromList: false,
        fromType: false,
        newIniFileName: '',
        newIniFileContent: '',
        newTtsFileName: '',
        newTtsFileContent: '',
        path: '',
        extType: '',
        extWhiteList: '',
        extName: '',
        extPassword: '',
        extDoubleAuth: '',
        extBlockNoPhone: '',
        extAcsses: '',
        newExtFromType: '',
        viewFile: false,
        fileTextContent: '',
        newFolderType: '',
        newFolderName: '',
        viewFilePath: '',
        fileEdit: false,
        csvFile: [],
        audioPlayer: false,
        audioPath: '',
        file: null,
        uploadStatus: false,
        items: [

        ],
        selectExtTypes: [
            { title: 'תיקייה', value: '' },
            { title: 'תפריט', value: 'menu' },
            { title: 'השמעת קבצים', value: 'playfile' },
            { title: 'חדר ועידה', value: 'confbridge' },
            { title: 'כניסה לניהול', value: 'admin_login' },
            { title: 'הקלטות', value: 'record' },
            { title: 'ניתוב שיחות', value: 'routing' },
            { title: 'ניתוב שיחה לפי זמנים', value: 'routing_time' },
            { title: 'ניתוב שיחה למערכת אחרת', value: 'routing_yemot' },
            { title: 'השמעת ניקוד', value: 'points_say_total' },
            { title: 'חזרה להשמעה אחרונה', value: 'last_play' },
            { title: 'תא קולי מוגבל ל100 הודעות', value: 'voice_mail' },
            { title: 'הוספת מספר לרשימת תפוצה', value: 'template_add_number' },
            { title: 'הסרת מספר מרשימת תפוצה', value: 'template_remove_number' },
            { title: 'תפריט כוכבית', value: 'menu_star' },
            { title: 'הוראות הפעלה', value: 'message_options_menu' },
            { title: 'התראות צבע אדום', value: 'oref_alerts' },
            { title: 'היסטוריית הגל השקט', value: 'oref_alerts_quiet_wave' },
            { title: 'זמני היום בהלכה', value: 'zmanim' },
            { title: 'שערי מט״ח', value: 'exchange_rates' },
            { title: 'השמעת הודעה אחת', value: 'play_and_return' },
            { title: 'תא קולי והעתק לדוא״ל', value: 'voicemail_email' },
            { title: 'חדר ועידה המוגבל לכמות משתתפים', value: 'conference_amount' },
            { title: 'השמעת הודעה לפי תאריך', value: 'toplay_time' },
            { title: 'חלוקת תהילים', value: 'chapter_receive' },
            { title: 'טריוויה', value: 'trivia_questions' },
            { title: 'השעה כעת', value: 'say_hour_and_minute' },
            { title: 'חלוקת מספרים', value: 'approval_number' },
            { title: 'קבלת נתונים והקלטות', value: 'recording_and_entering_data' },
            { title: 'השמעות אישיות', value: 'phone_play_list' },
            { title: 'הפניה למספר 1800', value: 'routing_1800' },
            { title: 'תפריט עם זיהוי דיבור', value: 'menu_voice' },
            { title: 'שליחת הודעת SMS', value: 'sending_sms' },
            { title: 'הפנייה לשלוחות לפי זמנים', value: 'go_to_folder_time' },
            { title: 'המרת קול לטקסט', value: 'stt_dir_all_file' },
            { title: 'הוספת ניקוד', value: 'points_save' },
            { title: 'ניתוק השיחה', value: 'hangup' },
            { title: 'שידור חי מדומה', value: 'playdir_time' },
            { title: 'קבלת מספר אישי', value: 'private_did_customer' },
            { title: 'מודול צינתוקים', value: 'tzintuk' },
            { title: 'פילטר לפי רשימות (list_all_information.ini)', value: 'go_to_folder_from_list_all_information' },
            { title: 'סליקת אשראי - נדרים', value: 'nedarim_plus' },
            { title: 'סליקת אשראי - פלאקארד', value: 'pelecard' },
            { title: 'סליקת אשראי - קארדקום', value: 'cardcom' },
            { title: 'חלוקת משניות', value: 'chapter_receive_mishnayot_select' },
            { title: 'מעקב לימודים', value: 'study_tracking' },
            { title: 'פילטר לפי כמות אנשים בשלוחה', value: 'go_to_folder_count' },
            { title: 'מעבר לשלוחה אחרת', value: 'go_to_folder' },
            { title: 'מוזיקה בהמתנה', value: 'music_on_hold' },
            { title: 'מודול תור', value: 'queue' },
            { title: 'שליחת פקס', value: 'send_fax' },
            { title: 'קבלת פקס', value: 'recv_fax' },
            { title: 'מבחן רגיל', value: 'examination' },
            { title: 'סקר', value: 'seker' },
            { title: 'מעקב גיוס תרומות', value: 'fundraising' },
            { title: 'כמות חברים פעילים', value: 'members_active' },
            { title: 'חישוב מונה', value: 'counter_calculator' },
            { title: 'התרמות - מאצ׳ינג', value: 'donation_campaign' },
            { title: 'הוספת והורדות נקודות למשתמש', value: 'points_edit' },
            { title: 'ניהול רשימת תפוצה', value: 'yemot_dialer_campaign_list' },
            { title: 'הקצאת פרקי תהילים', value: 'tehillim_select_save_and_listen' },
            { title: 'נוספת ניקוד למשתמש אחר', value: 'points_to_other_id' },
            { title: 'מבחן אמריקאי', value: 'examination_american' },
            { title: 'חסימת משתמש', value: 'block_id_type' },
            { title: 'חלוקת קופונים', value: 'coupon' },
            { title: 'סליקת אשראי - כללי', value: 'credit_card' },
            { title: 'הודעות אישיות', value: 'id_message' },
            { title: 'השמעת הודעות ברצף', value: 'id_list_message' },
            { title: 'הקלטת הודעות מערכת', value: 'record_system_messages' },
            { title: 'הפעלת שלוחה רנדומלית', value: 'folder_play_random' },
            { title: 'תזמון הפעלת קובץ', value: 'playfile_time' },
            { title: 'הפעלת קמפיין מהירה', value: 'yemot_dialer_campaign_start' },
            { title: 'פילטר משתמשים לפי רשימת תפוצה', value: 'template_filter' },
            { title: 'הזמנת מוצרים', value: 'sale_products' },
            { title: 'הודעה יומית ומעבר לשלוחה אחרת', value: 'daily_message' },
            { title: 'העברה לשלוחה לפי זמנים', value: 'go_to_folder_date' },
            { title: 'דיווח משימות', value: 'tasks_report' },
            { title: 'בדיקת יתרת יחידות', value: 'checking_units' },
            { title: 'שעון נוכחות', value: 'time_keeper' },
            { title: 'ניתוב השיחה לכתובת IP', value: 'routing_ip' },
            { title: 'ניקוד ללקוח על קניה', value: 'points_and_rating' },
            { title: 'הגבלת משך זמן השיחה', value: 'limit_call_seconds' },
            { title: 'מחשבון אחוזי תוספת', value: 'calculator_add_percentage' },
            { title: 'פילטר כניסה', value: 'access_filter' },
            { title: 'המספר כעת', value: 'number_now_is' },
            { title: 'השמעת כמות נרשמים', value: 'say_amount_subscribers' },
            { title: 'ספירת כמות נכנסים לשלוחה', value: 'amount_incoming_phone_numbers' },
            { title: 'ניתוביה', value: 'nitoviya' },
            { title: 'שמיעת מספר ניתוביה', value: 'nitoviya_b_say_number' },
            { title: 'מאצ׳ינג ואפשרויות נוספות', value: 'donation_campaign_some_actions' },
            { title: 'הוספת וקבלת שיחות', value: 'private_did' },
        ],
        extAcssesItems: [
            { title: 'כולם מורשים להכנס לשלוחה', value: '', hint: 'אין צורך בהרשאת כניסה בשלוחה' },
            { title: 'כניסה לפי זיהוי אישי', value: 'enter_id=yes', hint: 'כניסה לפי זיהויים אישיים מוגדרים מראש' },
            { title: 'רשימה לבנה', value: 'white_list=yes', hint: 'כניסה לפי רשימת מספרים המוגדרת בקובץ "WhiteList.ini"' },
            { title: 'רשימה שחורה', value: 'black_list=yes', hint: 'כניסה לפי רשימת מספרים המוגדרת בקובץ "BlackList.ini"' },
        ],
        ranameOld: '',
        ranameNew: '',
        ranameDialog: false,
        copyAlert: false,
        pathToCopy: '',
        moveAlert: false,
        pathToMove: '',
        showFiles: true,
        showMsg: false,
        showStatistics: false,
        showSettings: false,
        location: null,
        ivrMsgList: '',
        messages: [

        ],
        uploadMsgDialog: false,
        messageToUpload: '',
        messageBodyToUpload: '',
        msgFile: null,
        uploadProgress: 0,
        totalEntersCount: '',
        nowPlaying: '',
        selectedFiles: [],
        showMenu: false,
        x: 0,
        y: 0,
        itemToAction: {},
        multiCutAlert: false,
        multiCopyAlert: false,
        some: {
            "modules": {
                "record": {
                    "name": "הקלטות",
                    "type": "record",
                    "settings": {
                        "record_password": {
                            "type": "text",
                            "name": "סיסמא להקלטה"
                        },
                        "record_title": {
                            "type": "yesno",
                            "yes-value": "tfr",
                            "no-value": "yes",
                            "name": "לשאול האם להקליט כותרת?"
                        },
                        "some-setting": {
                            "type": "dropdown",
                            "options": {
                                "opt1": "אפ1",
                                "opt2": "אפ2"
                            }
                        }
                    }
                }
            }
        },
        settings: {},
        settingsData: {
            all: [],
            custom: []
        },
        cmOptions: {
            disabled: false,
            indentWithTab: false,
            tabSize: 2,
            autofocus: false,
            // placeholder: "input...",
            // backgroundColor: "blue",
            language: "javascript",
            // "theme": "oneDark",
            phrases: "en-us"
        },
        keys: [],
        suggestions: [],
        showSuggestions: false
    }),
    watch: {
        audioPlayer(val) {
            !val && document.getElementById('audio').pause()
            val && document.getElementById('audio').play()
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: '',
                    align: 'start',
                    sortable: false,
                    value: 'icon',
                    width: "0%"
                },
                { text: this.$t('extNumberOrName'), value: 'name', sortable: false, },
                { text: this.$t('type'), value: 'fileType' },
                { text: this.$t('extType'), value: 'extType' },
                { text: this.$t('extName'), value: 'extTitle' },
                { text: this.$t('path'), value: 'what' },
                { text: this.$t('date'), value: 'mtime' },
                { text: this.$t('size'), value: 'size' },
                { text: this.$t('actions'), value: 'actions', sortable: false }
            ]
        },
        msgHeaders() {
            return [
                {
                    text: this.$t('fileName'),
                    align: 'start',
                    sortable: false,
                    value: 'name'
                },
                { text: this.$t('message'), value: 'message' },
                { text: this.$t('length'), value: 'durationStr' },
                { text: this.$t('actions'), value: 'actions', sortable: false },
            ]
        }
    },
    methods: {
        loadData() {
            (async () => {
                this.path = this.$route.query.path;
                const path = this.path;
                const body = { token: sessionStorage.token, path: path };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetIvrTree`, body);
                this.items = response.data.items;
                const fileTypes = {
                    EXT: this.$t('extnetion'),
                    DIR: this.$t('folder'),
                    INI: this.$t('settingsFile'),
                    AUDIO: this.$t('audioFile'),
                    BIN: "קובץ בינארי",
                    TTS: this.$t('readFile'),
                    YMGR: this.$t('logFile'),
                }
                const fileIcons = {
                    EXT: 'mdi-dialpad',
                    DIR: 'mdi-folder-open-outline',
                    INI: 'mdi-pencil',
                    AUDIO: 'mdi-headphones',
                    BIN: 'mdi-cogs',
                    TTS: 'mdi-bullhorn-outline',
                    YMGR: 'mdi-text',
                }
                const extTypes = {
                    playfile: 'השמעת קבצים',
                    confbridge: 'חדר ועידה',
                    admin_login: 'כניסה לניהול',
                    record: 'הקלטות',
                    routing: 'ניתוב שיחות',
                    routing_time: 'ניתוב שיחה לפי זמנים',
                    routing_yemot: 'הפניה למערכת אחרת',
                    points_say_total: 'השמעת הניקוד',
                    last_play: 'חזרה להשמעה אחרונה',
                    voice_mail: 'תא קולי עד 100 הודעות',
                    template_add_number: 'הוספת מספר לרשי״ת',
                    template_remove_number: 'הסרת מספר מרשי״ת',
                    menu_star: 'תפריט כוכבית',
                    message_options_menu: 'הוראות הפעלה',
                    oref_alerts: 'צבע אדום',
                    oref_alerts_quiet_wave: 'הגל השקט',
                    zmanim: 'זמני היום',
                    exchange_rates: 'שערי מט״ח',
                    play_and_return: 'השמעת הודעה אחת',
                    voicemail_email: 'תא קולי למייל',
                    conference_amount: 'חדר ועידה מוגבל לכמות משתתפים',
                    toplay_time: 'השמעת הודעה לפי תאריך',
                    chapter_receive: 'חלוקת תהילים',
                    trivia_questions: 'טריוויה',
                    say_hour_and_minute: 'השעה כעת',
                    approval_number: 'חלוקת מספרים',
                    recording_and_entering_data: 'קבלת נתונים',
                    phone_play_list: 'השמעות אישיות',
                    routing_1800: 'הפניה למספר 1800',
                    menu_voice: 'תפריט עם זיהוי דיבור',
                    sending_sms: 'שליחת sms',
                    go_to_folder_time: 'הפניה לתיקיות לפי זמנים',
                    stt_dir_all_file: 'המרת קול לטקסט',
                    points_save: 'הוספת ניקוד',
                    hangup: 'ניתוק השיחה',
                    playdir_time: 'שידור חי מדומה',
                    private_did_customer: 'קבלת מספר אישי',
                    tzintuk: 'מודול צינתוקים',
                    go_to_folder_from_list_all_information: 'פילטר לפי רשימות',
                    nedarim_plus: 'סליקת אשראי - נדרים',
                    pelecard: 'סליקת אשראי - פלאקארד',
                    cardcom: 'סליקת אשראי - קארדקום',
                    chapter_receive_mishnayot_select: 'חלוקת משניות',
                    study_tracking: 'מעקב לימודים',
                    go_to_folder_count: 'הפניה לפי כמות אנשים',
                    go_to_folder: 'מעבר לשלוחה אחרת',
                    music_on_hold: 'מזיקה בהמתנה',
                    queue: 'מודול תור',
                    send_fax: 'שליחת פקס',
                    recv_fax: 'קבלת פקס',
                    examination: 'מודול מבחן',
                    seker: 'סקר',
                    fundraising: 'מעקב גיוס תרומות',
                    members_active: 'כמות חברים פעילים',
                    counter_calculator: 'חישוב מונה',
                    donation_campaign: 'התרמות - מאצ׳ינג',
                    points_edit: 'הוספת/הורדת נקודות',
                    yemot_dialer_campaign_list: 'ניהול רשי״ת',
                    tehillim_select_save_and_listen: 'הקצאת פרקי תהילים',
                    points_to_other_id: 'הוספת ניקוד למשתמש אחר',
                    examination_american: 'מבחן אמריקאי',
                    block_id_type: 'חסימת משתמש',
                    coupon: 'חלוקת קופונים',
                    credit_card: 'סליקת אשראי - כללי',
                    id_message: 'הודעות אישיות',
                    id_list_message: 'השמעת הודעות ברצף',
                    record_system_messages: 'הקלטת הודעות מערכת',
                    folder_play_random: 'הפעלת שלוחה רנדומלית',
                    playfile_time: 'תזמון הפעלת קובץ',
                    yemot_dialer_campaign_start: 'הפעלת קמפיין מהירה',
                    template_filter: 'פילטר משתמשים לפי רש״ית',
                    sale_products: 'הזמנת מצרים',
                    daily_message: 'הודעה יומית ומעבר לשלוחה אחרת',
                    go_to_folder_date: 'העברה לשלוחה לפי זמנים',
                    tasks_report: 'דיווח משימות',
                    checking_units: 'בדיקת יתרת יחידות',
                    time_keeper: 'שעון נוכחות',
                    routing_ip: 'ניתוב השיחה לIP',
                    points_and_rating: 'נקודות ללקוח על קניה',
                    limit_call_seconds: 'הגבלת זמן שיחה',
                    calculator_add_percentage: 'מחשבון אחוזי תוספת',
                    access_filter: 'פילטר כניסה',
                    number_now_is: 'המספר כעת',
                    say_amount_subscribers: 'השמעת כמות נרשמים בקבלת נתונים',
                    amount_incoming_phone_numbers: 'ספירת כמות כניסות לשלוחה',
                    nitoviya: 'ניתוביה',
                    nitoviya_b_say_number: 'שמיעת מספר ניתוביה',
                    donation_campaign_some_actions: 'מאצ׳ינג ואפשרויות נוספות',
                    private_did: 'הוצאת וקבלת שיחות',
                    menu: 'תפריט',
                }
                const extIcons = {
                    playfile: 'mdi-playlist-music',
                    confbridge: 'mdi-cellphone-cog',
                    admin_login: 'mdi-cog',
                    record: 'mdi-record-rec',
                    routing: 'mdi-routes',
                    routing_time: 'mdi-routes',
                    routing_yemot: 'mdi-routes',
                    points_say_total: 'mdi-dots-hexagon',
                    last_play: 'mdi-replay',
                    voice_mail: 'mdi-voicemail',
                    template_add_number: 'mdi-phone-plus',
                    template_remove_number: 'mdi-phone-minus',
                    menu_star: 'mdi-star',
                    message_options_menu: 'mdi-power-settings',
                    oref_alerts: 'mdi-led-on',
                    oref_alerts_quiet_wave: 'mdi-led-on',
                    zmanim: 'mdi-clock',
                    exchange_rates: '',
                    play_and_return: 'mdi-play-speed',
                    voicemail_email: 'mdi-voicemail',
                    conference_amount: '',
                    toplay_time: '',
                    chapter_receive: '',
                    trivia_questions: 'mdi-help',
                    say_hour_and_minute: '',
                    approval_number: 'mdi-paper-roll',
                    recording_and_entering_data: '',
                    phone_play_list: '',
                    routing_1800: 'mdi-routes',
                    menu_voice: '',
                    sending_sms: 'mdi-message-text',
                    go_to_folder_time: '',
                    stt_dir_all_file: '',
                    points_save: '',
                    hangup: 'mdi-phone-hangup',
                    playdir_time: '',
                    private_did_customer: '',
                    tzintuk: 'mdi-phone-ring',
                    go_to_folder_from_list_all_information: '',
                    nedarim_plus: 'mdi-credit-card',
                    pelecard: 'mdi-credit-card',
                    cardcom: 'mdi-credit-card',
                    chapter_receive_mishnayot_select: '',
                    study_tracking: '',
                    go_to_folder_count: '',
                    go_to_folder: '',
                    music_on_hold: '',
                    queue: '',
                    send_fax: 'mdi-fax',
                    recv_fax: 'mdi-fax',
                    examination: 'mdi-note-edit-outline',
                    seker: 'mdi-poll',
                    fundraising: '',
                    members_active: '',
                    counter_calculator: '',
                    donation_campaign: '',
                    points_edit: '',
                    yemot_dialer_campaign_list: '',
                    tehillim_select_save_and_listen: '',
                    points_to_other_id: '',
                    examination_american: 'mdi-ab-testing',
                    block_id_type: '',
                    coupon: 'mdi-ticket',
                    credit_card: 'mdi-credit-card',
                    id_message: '',
                    id_list_message: '',
                    record_system_messages: '',
                    folder_play_random: '',
                    playfile_time: '',
                    yemot_dialer_campaign_start: '',
                    template_filter: '',
                    sale_products: 'mdi-cart',
                    daily_message: '',
                    go_to_folder_date: '',
                    tasks_report: '',
                    checking_units: '',
                    time_keeper: '',
                    routing_ip: '',
                    points_and_rating: '',
                    limit_call_seconds: 'mdi-timer',
                    calculator_add_percentage: '',
                    access_filter: '',
                    number_now_is: '',
                    say_amount_subscribers: '',
                    amount_incoming_phone_numbers: '',
                    nitoviya: '',
                    nitoviya_b_say_number: '',
                    donation_campaign_some_actions: '',
                    private_did: '',
                    menu: 'mdi-phone-dial',
                }
                for (let item of this.items) {
                    item.icon = fileIcons[item.fileType] || item.icon;
                    item.fileType = fileTypes[item.fileType] || item.fileType;
                    item.icon = extIcons[item.extType] || item.icon;
                    item.extType = extTypes[item.extType] || item.extType;
                }
                if (this.$route.query.path !== "ivr2:/") {
                    this.location = this.$route.query.path.replace(":", "/").split("/");
                }
                else {
                    this.location = this.$route.query.path.split("/");
                }
                for (let item of this.location) {
                    if (item === undefined | item === "") {
                        this.location.splice(1, 1)
                    }
                }
                this.keys = (await axios.get('/keys.json')).data
            })();
        },
        loadMsg() {
            (async () => {
                this.path = this.$route.query.path;
                const path = this.path;
                const body = { token: sessionStorage.token, path: path };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetIVR2Dir`, body);
                this.messages = response.data.messages;
                const messages = {
                    "M0000.wav": "הודעת ברוכים הבאים - הודעה ראשונה בשלוחה",
                    "M0003.wav": "ניתן להיכנס ממספר ישראלי בלבד",
                    "M0010.wav": "כותרת הקובץ היא",
                    "M0011.wav": "כותרת השידור היא",
                    "M0012.wav": "לשמיעת כמות המספרים השונים ששמעו הודעה זו הקישו 1, לבדיקה האם מספר מסוים שמע את ההודעה הקישו 2, לחזרה הקישו כוכבית",
                    "M0013.wav": "כמות המספרים השונים ששמעו את ההודעה היא",
                    "M0014.wav": "אנא הקישו מספר טלפון, לסיום הקישו סולמית",
                    "M0015.wav": "מספר הטלפון שהוקש לא שמע את ההודעה",
                    "M0016.wav": "מספר הטלפון שהוקש שמע את ההודעה",
                    "M0099.wav": "הודעה אחרונה בשלוחה",
                    "M0100.wav": "להקלטת כותרת לקובץ, הקישו 1, להמשך ללא הקלטת כותרת הקישו 2",
                    "M0101.wav": "להקלטת כותרת לשידור, הקישו 1, להמשך ללא הקלטת כותרת הקישו 2",
                    "M0102.wav": "אנא הקליטו את כותרת השידור לאחר הצליל ובסיום הקישו סולמית",
                    "M1000.wav": "תפריט. אנא הקישו את מספר השלוחה",
                    "M1001.wav": "המקש שֶהוֹקַש שגוי",
                    "M1002.wav": "לא הוקשה בחירה",
                    "M1003.wav": "אורך",
                    "M1004.wav": "דקות",
                    "M1005.wav": "סוף הודעות",
                    "M1006.wav": "beep",
                    "M1007.wav": "השידור החי עדיין לא החל. להמתנה לַשידור הַקִישוּ 1, להאזנה לשידורים קודמים הַקִישוּ 2",
                    "M1008.wav": "השידור יחל מיד עם כניסתו של המנהל.",
                    "M1009.wav": "לשמיעת ההקלטה הקישו 1. לאישור ההקלטה הקישו 2. להקלטה מחודשת 3. לביטול וחזרה הקישו 4",
                    "M1010.wav": "הֶקְלַטֶתֶם בהצלחה את קובץ מספר",
                    "M1011.wav": "להקלטה נוספת הַקִישוּ 1. לְסיום הַקִישוּ 2 או הַמתינו.",
                    "M1012.wav": "אנא הקליטו את הודעתכם לאחר הצליל. בסיום הַקישו סולמית",
                    "M1166.wav": "ביפ תחילת הקלטה- beep record",
                    "M1013.wav": "עד היום צברת",
                    "M1014.wav": "נקודות",
                    "M1015.wav": "מספר הטלפון שלכם אינו מזוהה",
                    "M1016.wav": "המספר האישי שלכם אינו מזוהה",
                    "M1017.wav": "קיבלת",
                    "M1018.wav": "אין נתונים על השמעה אחרונה",
                    "M1019.wav": "הנך בדקה",
                    "M1020.wav": "מתוך",
                    "M1021.wav": "שלוחה",
                    "M1022.wav": "האזנה",
                    "M1023.wav": "לא ניתן לצרף את טלפון",
                    "M1024.wav": "הוספתם בהצלחה לרשימת התפוצה את טלפון מספר",
                    "M1025.wav": "לא ניתן להסיר את טלפון",
                    "M1026.wav": "שלום ותודה",
                    "M1027.wav": "הסרת מספר. הנכם מבקשים להסיר את טלפון מספר",
                    "M1028.wav": "האם הנכם בטוחים? לאישור ההסרה הַקישו1 , לֶביטול הקישו 2, או נתקו את השיחה.",
                    "M1029.wav": "הסרת מספר הטלפון בוטלה",
                    "M1030.wav": "הסרתם בהצלחה מרשימת התפוצה את טלפון מספר",
                    "M1031.wav": "להוראות הפעלה הקישו1. להשארת הודעה למנהל המערכת הקישו2. לחזרה למיקום האחרון אליו הֶאֵזַנְתֶם הקישו3. לשמיעת כל התכנים המוקלטים במערכת הקישו 4. לפתיחת מערכת וואצפון שבהקשה על 8 וסולמית עוברים ישירות למערכת שלנו הקישו 5. לרשימות ההשמעה האישיות שלכם הקישו 6 להקלטת השמעות הקישו 7",
                    "M1032.wav": "הוראות הפעלה למערכת שימו לב! ההוראות המושמעת כאן הן לפי הגדרות ברירת המחדל במערכת. בעת מעבר בין שלוחות במערכת, ניתן להקיש סולמית לחזרה שלב אחד אחורה, וכוכבית לחזרה לתפריט הראשי בעת שמיעת קובץ: לחזרה עשר שניות אחורה הקישו 1, לדילוג עשר שניות קדימה הקישו 3. לחזרה 5 דקות אחורה הקישו 4, לדילוג 5 דקות קדימה הקישו 6. לעצירה זמנית של ההשמעה הקישו 5, לביטול העצירה והמשך האזנה הקישו שוב 5. לשינוי מהירות ההשמעה למהירות נמוכה יותר הקישו 7, לשינוי למהירות גבוהה יותר הקישו 9. לחזרה למהירות רגילה הקישו 0. למעבר לקובץ הבא הקישו 8, לחזרה לקובץ קודם הקישו 2. לאפשרויות נוספות הקישו כוכבית. ליציאה מהשלוחה הקישו סולמית. בעת השתתפות בחדר ועידה: להצבעה, ביטול השתקה ואפשרויות נוספות הקישו כוכבית ופעלו לפי ההוראות.",
                    "M1033.wav": "לגישה אנא הכנס כמנהל",
                    "M1034.wav": "לאישור הקישו 1, להקשה מחודשת 2.",
                    "M1035.wav": "לא הקּשתּם את מינימום הספרות הנדרשות",
                    "M1036.wav": "אנא הקישו את מספר הקובץ וסולמית לֶסיום",
                    "M1037.wav": "הכותרת הוקלטה בהצלחה",
                    "M1038.wav": "אנא הקליטו את כותרת הקובץ לאחר הצליל ובסיום הקישו סולמית",
                    "M1039.wav": "אנא הקישו את מספר השלוחה לניתוב וסולמית",
                    "M1040.wav": "ליציאה הקישו כוכבית",
                    "M1041.wav": "המענה סַגוּר כעת, אנא נסו שוב בשעות הפעילות",
                    "M1042.wav": "שלוחה זו אינה מוגדרת במערכת",
                    "M1043.wav": "יתרת יחידות נמוכה לביצוע השיחה",
                    "M1044.wav": "אנא נסו שנית ממספר טלפון מזוהה",
                    "M1045.wav": "ברוכים הבאים למערכת ההזמנות של המערכות החינמיות, לקבלת מערכת הקישו 1",
                    "M1046.wav": "ניתן לפתוח מערכת אחת בשבוע, אנא נסו שוב בשבוע הבא",
                    "M1047.wav": "אנא בחרו סיסמת ניהול ולסיום הקישו סולמית",
                    "M1048.wav": "לצערינו אין כרגע מספרי טלפון להקצאה, אנא נסו שוב במועד מאוחר יותר",
                    "M1049.wav": "מזל טוב - פתחתם מערכת חינמית משלכם, מספר הטלפון של המערכת הוא",
                    "M1050.wav": "הטלפון של מנהל המערכת",
                    "M1051.wav": "סיסמת הניהול היא",
                    "M1052.wav": "לשמיעה מחודשת של מספר המערכת הקישו 1. לֶסיום הקישו 2",
                    "M1053.wav": "אנא אֶמׂר במספר מילים עבור מה מיועדת המערכת",
                    "M1054.wav": "אנא הקליטו את שמכם הפרטי אות אחר אות. לדוגמא לַשֶם משה אִמרו משה, מם שין הֶי. בסיום הַקישו סולמית",
                    "M1055.wav": "אנא הקליטו את שם המשפחה שלכם אות אחר אות. לדוגמא למשפחת כהן אִמרו כהן, כף הֶי נון. בסיום הַקישו סולמית",
                    "M1056.wav": "להלן הפרטים שנקלטו",
                    "M1057.wav": "לאישור הקישו 1 לשמיעה חוזרת 2 להקלטה מחדש הקישו 3",
                    "M1058.wav": "סיסמה קצַרה מידי",
                    "M1059.wav": "במידה וברצונכם להכניס טלפון נוסף בתור מנהל מערכת, הַקישו את מספרו וסולמית לֶסיום. לֶדילוג הַקישו סולמית או הַמתינו.",
                    "M1060.wav": "אנא השאירו הודעתכם לאחר הִשַמע הצליל. לֶסיום נתקו את השיחה או הַקישו סולמית",
                    "M1061.wav": "לשמיעת ההודעה הקישו 1, לֶאישור הקישו 2, להקלטה מחודשת 3, לביטול וחזרה הקישו 4.",
                    "M1062.wav": "מיד תועברו להקלטת הברכה, לפני בקשת הברכה מקבלים החלטה טובה בתורה מצוות ומעשים טובים ומכריזים יחי.. אנא השאירו את בקשת הברכה שמכם שם אמכם. בסיום ההקלטה הקישו סולמית",
                    "M1063.wav": "לאישור ושליחת בקשת הברכה, הקישו 1 לשמיעת בקשת הברכה 2 להקלטה מחודשת של בקשת הברה 3",
                    "M1064.wav": "קיבלתם תשובה מהרבי שליטא מלך המשיח באמצעות האיגרות קודש בכרך",
                    "M1065.wav": "עמוד",
                    "M1066.wav": "ועמוד",
                    "M1067.wav": "לשמיעה חוזרת של מיקום התשובה הקש 1 לקבלת העתק ממכתב התשובה מיידית לתיבת הדואר האלקטרוני שלכם הקישו 2. לקבלת העתק ממכתב התשובה בדואר רגיל לביתכם הקישו 3. לחזרה לתפריט הראשי הקישו *",
                    "M1068.wav": "על מנת שנוכל לשלוח את הְעֶתֶק התשובה לביתכם, אנא הקליטו את הפרטים לְמשלוח - שלב אחר שלב",
                    "M1069.wav": "אנא הקליטו את מספר הבית, ובסיום הַקישו סולמית",
                    "M1070.wav": "אנא הקליטו את מספר הדירה, ובסיום הַקישו סולמית",
                    "M1071.wav": "אנא הקליטו את שם העיר אות אחר אות. לדוגמא לעיר חיפה אִמרו חיפה, חת יוד פְּי הֶי. בסיום הַקישו סולמית",
                    "M1072.wav": "להלן הפרטים למשלוח הדואר",
                    "M1073.wav": "אנא הקישו על מקשי הטלפון, את מספר מיקוד הדואר בכתובת שציינתם, בסיום הַקישו סולמית",
                    "M1074.wav": "אנא הקישו על מקשי הטלפון, מספר טלפון בו במידת הצורך יהיה ניתן ליצור אתכם קשר, בסיום הַקישו סולמית",
                    "M1075.wav": "תודה רבה, בקשתכם למשלוח הְעֶתֶק התשובה בדואר, התקבלה בהצלחה",
                    "M1076.wav": "מספר הפּנִיַה הוא",
                    "M1077.wav": "לסיום ומַעַבַר לתפריט הראשי, הקישו 1. לשמיעת מספר הפּנִיַה שנית, לצורך בירור עתידי, הקישו 2",
                    "M1078.wav": "לְאישור הקישו 1. להקלטה מחודשת של הפרטים הקישו 2",
                    "M1079.wav": "אנא הקליטו את שם הרחוב אות אחר אות, לדוגמא לרחוב חבצלת אִמְרוּ: חבצלת, ח,ב,צ,ל,ת. בסיום הַקישו סולמית.",
                    "M1080.wav": "שגיאה",
                    "M1081.wav": "הפרק אותו קיבלת לקריאה הינו פרק (מיועד לחלוקת פרק אחד או שניים)",
                    "M1082.wav": "וכן את פרק (מיועד לחלוקה של 2 פרקים) (עד פרק בקריאה אישית)",
                    "M1083.wav": "תזכה למצוות (וכן את כל ההודעות לאחרי השמעת הפרקים)",
                    "M1084.wav": "הפרקים אותם קיבלתם לקריאה הינם פרקים (מיועד לחלוקה של מעל 2 פרקים)",
                    "M1085.wav": "עד פרק (מיועד לחלוקה של מעל 2 פרקים)",
                    "M1086.wav": "הפרשה אותה קיבלת לקריאה הינה פרשת",
                    "M1087.wav": "עד פרשת / וכן את פרשת",
                    "M1088.wav": "עד פרשת",
                    "M1089.wav": "תפריט בחירה שְלַב...",
                    "M1090.wav": "אנא הקישו את בחירתכם ב...",
                    "M1091.wav": "סְפַרוֹת",
                    "M1092.wav": "לפרשת",
                    "M1093.wav": "תזכורת ספירת העומר",
                    "M1094.wav": "הודעה לאחר תזכורת ספירת העומר - ברירת מחדל ניתן ללמוד את השיעור היומי מפי הרב יוסף יצחק כץ",
                    "M1095.wav": "שגיאת ניהול, לא הוגדר סוג זיהוי",
                    "M1096.wav": "להקלטה אנא הקישו את מספר התיקייה וסולמית לסיום. להקלטה בתיקייה הזמנית הקישו סולמית. להקלטה בתתי תיקיות הקישו את הכתובת המלאה, כאשר בין תיקייה לתיקייה הקישו כוכבית. בסיום הכתובת המלאה הקישו סולמית.",
                    "M1097.wav": "אין הרשאה להקלטה בתיקיה זו",
                    "M1098.wav": "כבר קיבלתם ניקוד על ערך זה",
                    "M1099.wav": "אין הודעה להשמעה",
                    "M1100.wav": "נא הקש את הסיסמה ובסיום הקש סולמית",
                    "M1101.wav": "סיסמה שגויה",
                    "M1102.wav": "אין לכם הרשאת גישה לתיקייה זו",
                    "M1103.wav": "אנא הקישו את המספר האישי וסולמית לְסיום",
                    "M1104.wav": "המספר האישי שֶ הוּקַש שגוי",
                    "M1105.wav": "התחברתם בהצלחה",
                    "M1106.wav": "שלום לך מספר אישי",
                    "M1107.wav": "ניכר כי הנכם משתמשים חדשים במערכת",
                    "M1108.wav": "אנא אמרו את שמכם ושם משפחתכם לאחר השמע הצליל",
                    "M1109.wav": "אם אתם מרוצים מההקלטה הקישו 1 להקלטה מחודשת 2",
                    "M1110.wav": "הקלטת השם נקלטה בהצלחה",
                    "M1111.wav": "שלום ל..",
                    "M1112.wav": "תזכורת ספירת העומר",
                    "M1113.wav": "הודעה לאחר תזכורת ספירת העומר - ברירת מחדל ניתן ללמוד את השיעור היומי מפי הרב יוסף יצחק כץ",
                    "M1114.wav": "שלוחה זו סגורה כעת, אנא נסו שוב בשעות הפעילות",
                    "M1115.wav": "לא ניתן להכנס שוב עם משתמש זה",
                    "M1116.wav": "עד היום צברת",
                    "M1117.wav": "נקודות",
                    "M1120.wav": "לא ניתן לבצע פעולה זו. שלום ותודה. (השלוחה אליה ביקשת לעבור אינה ניתנת להפעלה עקב חוסר בהגדרות, אנא פנה למנהל המערכת).",
                    "M1170.wav": "המערכת סגורה בשבתות ובימים טובים",
                    "M1199.wav": "שעון מתקטק",
                    "M1200.wav": "ענית בהצלחה",
                    "M1201.wav": "עדכון המשימה התקבל בהצלחה",
                    "M1202.wav": "תשובה נכונה תזכה אתכן עד",
                    "M1203.wav": "ברוכים הבאים למשחק הטריוויה",
                    "M1204.wav": "ועכשיו נשאל אתכם שאלה על הקטע שלמדתם",
                    "M1205.wav": "נקודות",
                    "M1206.wav": "הנך מועבר לשאלה הבאה",
                    "M1207.wav": "השאלה היא",
                    "M1208.wav": "אנא הקישו את מספר התשובה הנכונה",
                    "M1209.wav": "שעון מתקטק",
                    "M1210.wav": "תשובתך שגויה",
                    "M1211.wav": "תשובה ראשונה",
                    "M1212.wav": "תשובה שניה",
                    "M1213.wav": "תשובה שלישית",
                    "M1214.wav": "תשובה רביעית",
                    "M1215.wav": "אנא נסה שנית",
                    "M1216.wav": "התשובה הנכונה היא",
                    "M1217.wav": "נכון או לא נכון",
                    "M1218.wav": "לנכון הקישו 1 ללא נכון הקישו 0",
                    "M1219.wav": "התשובה היא",
                    "M1220.wav": "לא נכון",
                    "M1221.wav": "נכון",
                    "M1222.wav": "סך הניקוד שברשותך הוא",
                    "M1223.wav": "קיבלת",
                    "M1224.wav": "בחירה לא חוקית",
                    "M1225.wav": "השיא שלכם בטרוויה הוא",
                    "M1226.wav": "הנכם מתחילים משחק חדש",
                    "M1227.wav": "סך הניקוד במשחק החדש הוא",
                    "M1228.wav": "סיימתם בהצלחה את כל השאלות בטריוויה",
                    "M1229.wav": "סך הניקוד שצברתם במהלך המשחק הוא",
                    "M1230.wav": "כל הכבוד",
                    "M1231.wav": "להפעלה מחודשת של הטריוויה הקישו 1 לחזרה לתפריט הראשי הקישו 2",
                    "M1232.wav": "השיא החדש שלך הוא",
                    "M1233.wav": "כבר קיבלת ניקוד על תשובה זו",
                    "M1240.wav": "אולי בפעם אחרת",
                    "M1241.wav": "אופס, טעות",
                    "M1242.wav": "הפעם שגית",
                    "M1243.wav": "לא נורא",
                    "M1244.wav": "ממש... לא!",
                    "M1245.wav": "מענין, אבל זה לא זה",
                    "M1246.wav": "נסה שוב",
                    "M1247.wav": "שווה לקרוא את החומר פעם נוספת",
                    "M1250.wav": "אדיר",
                    "M1251.wav": "איזו בקיאות",
                    "M1252.wav": "אין כמוך",
                    "M1253.wav": "אתה ממש גאון",
                    "M1254.wav": "אתה פשוט עשר",
                    "M1255.wav": "וואו!! אתה מקסים",
                    "M1256.wav": "חכם כמוך לא רואים כל יום",
                    "M1257.wav": "יפה מאוד",
                    "M1258.wav": "יש במה להתגאות",
                    "M1259.wav": "יש לך ראש פיצוץ",
                    "M1260.wav": "כל הכבוד",
                    "M1261.wav": "לא יאומן!",
                    "M1262.wav": "מדהים",
                    "M1263.wav": "מיוחד",
                    "M1264.wav": "נפלא",
                    "M1265.wav": "תמיד אמרו עליך שאתה ילד מחונן",
                    "M1266.wav": "תמשיך כך",
                    "M1270.wav": "הנך מועבר להקלטת שאלה מספר",
                    "M1271.wav": "אנא הקליטו את השאלה לאחר השמע הצליל, לסיום הקישו סולמית",
                    "M1272.wav": "אנא הקליטו את התשובה הנכונה ובסיום הקישו סולמית",
                    "M1273.wav": "אנא הקליטו מסיח ראשון ובסיום הקישו סולמית",
                    "M1274.wav": "אנא הקליטו מסיח שני ובסיום הקישו סולמית",
                    "M1275.wav": "אנא הקליטו מסיח שלישי ובסיום הקישו סולמית",
                    "M1277.wav": "אם ברצונכם בהקלטת מסיח שלישי הקישו 1 להקלטת שאלה נוספת הקישו 2 לחזרה לתפריט הראשי הקישו 3",
                    "M1278.wav": "להקלטת שאלה נוספת הקישו 1 לחזרה לתפריט הראשי הקישו 2",
                    "M1279.wav": "להקלטת שאלה טריוויה אמריקאית הקישו 1 להקלטת שאלת נכון או לא נכון הקישו 2",
                    "M1280.wav": "להקלטת שאלה שהתשובה עליה נכון הקישו 1 להקלטת שאלה שהתשובה עליה לא נכון הקישו 2",
                    "M1281.wav": "השאלה הוקלטה בהצלחה",
                    "M1282.wav": "התשובה הנכונה הוקלטה בהצלחה",
                    "M1283.wav": "מסיח ראשון הוקלט בהצלחה",
                    "M1284.wav": "מסיח שני הוקלט בהצלחה",
                    "M1285.wav": "מסיח שלישי הוקלט בהצלחה",
                    "M1290.wav": "להקלטת שאלה חדשה הקישו 1 לעריכת שאלה קיימת הקישו 2",
                    "M1301.wav": "בשלוחה זו צברת",
                    "M1302.wav": "אי צבירת נקודות נוספות עדיין בתוקף",
                    "M1303.wav": "אי צבירת נקודות נוספות בתיקיה זו עדיין בתוקף",
                    "M1304.wav": "על ערך זה צברת",
                    "M1305.wav": "ההודעה קצרה מידי",
                    "M1306.wav": "ההודעה מבוטלת",
                    "M1307.wav": "תגובות",
                    "M1308.wav": "סוף תגובות",
                    "M1309.wav": "אין תגובות להשמעה",
                    "M1310.wav": "להקלטת תגובה הקישו 1 לשמיעת התגובות הקישו 2 להמשך הקישו 9 או המתינו",
                    "M1311.wav": "אנא הקש את מספר מערכת הלקוח עבורו להוציא את החשבונית",
                    "M1312.wav": "אין ארועים",
                    "M1313.wav": "אירועים להיום",
                    "M1314.wav": "אירועים ליום",
                    "M1315.wav": "לאירועים מהיום הקישו 1 או המתינו לאירועים מיום אחר הקישו 2",
                    "M1316.wav": "לבחירת תאריך עברי הקישו 1 לבחירת תאריך לועזי הקישו 2",
                    "M1317.wav": "אנא הקישו את התאריך העברי ב6 ספרות לדוגמא ליום ג תשרי בשנת עה הקישו ג 03, תשרי 01, עה 75",
                    "M1318.wav": " אנא הקישו את התאריך הלועזי ב6 ספרות לדוגמא ליום הראשון במרץ 2015 הקישו יום 01, חודש מרץ 03, ושנה ב2 ספרות - 15.",
                    "M1320.wav": "לדירוג הקש 1 לשמיעת הדירוגים הקש 2 להמשך הקישו 3 או המתינו",
                    "M1321.wav": "אנא דרג מ1 עד 5, כאשר 1 זה הדירוג הנמוך ביותר ו5 זה הדירוג הגבוה ביותר",
                    "M1322.wav": "אין זיהוי טלפוני. לא ניתן לדרג.",
                    "M1323.wav": "על פי רשומי המערכת כבר דירגת את השמעה זו.",
                    "M1324.wav": "הדרוג שהוקש שגוי ניתן לדרג בין 1 ל 5 בלבד",
                    "M1325.wav": "הדירוג התקבל בהצלחה",
                    "M1326.wav": "לשמיעת הדירוגים הקש 1 להמשך הקישו 2 או המתינו",
                    "M1327.wav": "הדירוג שלך הוא",
                    "M1328.wav": "כמות המדרגים",
                    "M1329.wav": "ממוצע הדירוג",
                    "M1330.wav": "בשלוחה זו עדיין אין השמעות",
                    "M1332.wav": "תודה רבה המערכת נפתחה בהצלחה מיד תקבלו שיחת טלפון מהמערכת החדשה שלכם אנו חזרו למספר המופיע על הצג להשלמת הרישום",
                    "M1333.wav": "באם ברצונכם בקבלת תגמול עבור המערכת אנא הקישו 1 למעבר להקשת ת.ז. לדילוג הקישו 2",
                    "M1334.wav": "אנא הקישו את ת.ז. של בעל המערכת ב9 ספרות",
                    "M1335.wav": "תעודת הזהות שגויה",
                    "M1336.wav": "לתשומת לבכם, השימוש עם מספר אישי זה הגיע לסיומו, שלום ותודה.",
                    "M1337.wav": "השעה כעת - ",
                    "M1339.wav": "דקות",
                    "M1340.wav": "נרשמת בהצלחה, אישור מספר",
                    "M1341.wav": "לסיום הקישו 1. לשמיעת מספר האישור פעם נוספת הקישו 2.",
                    "M1342.wav": "ההרשמה התמלאה. אנא נסו שוב מחר.",
                    "M1343.wav": "המספר עכשיו הוא",
                    "M1344.wav": "המספר לעכשיו עדיין לא הוגדר",
                    "M1345.wav": "אנא הקש את המספר להשמעה, לביטול עריכה הקש כוכבית וסולמית, להגדיר שהמספרים לעכשיו הסתיימו הקישו אפס וסולמית, להגדיר שהמספר עדיין לא הוגדר הקישו כוכבית כוכבית כוכבית וסולמית",
                    "M1346.wav": "המספרים לעכשיו הסתיימו",
                    "M1347.wav": "אין נתונים להשמעה",
                    "M1348.wav": "הרשמה זו התמלאה והסתיימה. שלום ותודה.",
                    "M1349.wav": "להוספת השמעה זו לרשימת השמעה ברירת המחדל הקישו 1 להוספת השמעה זו לרשימת השמעה אחרת הקישו 2 להוספת כל ההשמעות שבשלוחה זו לרשימת השמעה חדשה הקישו 3 לביטול הקישו כוכבית",
                    "M1350.wav": "מספרך אינו מזוהה במערכת. ניתן להוסיף לרשימות השמעה מטלפון מזוהה בלבד",
                    "M1351.wav": "ההשמעה צורפה בהצלחה ל... (רשימת השמעה)",
                    "M1352.wav": "אנא הקליטו את שם רשימת ההשמעה",
                    "M1353.wav": "לאישור הקישו 1 להקלטה מחודשת 2",
                    "M1354.wav": "שם רשימת ההשמעה נקלט בהצלחה",
                    "M1355.wav": "אנא הקישו את מספר רשימת ההשמעה להוספה וסולמית לסיום, ניתן להקיש כל מספר עד 10 ספרות.",
                    "M1356.wav": "הרשימות הקיימות הם:",
                    "M1357.wav": "הוספת קיצור דרך לכל השלוחה - ברשימת השמעה שלכם. אנא הקישו את מספר הרשימה להוספה וסולמית לסיום, ניתן להקיש כל רשימה שאינה קיימת ועד 10 ספרות.",
                    "M1358.wav": "רשימת השמעה זו כבר קיימת.",
                    "M1359.wav": "מספרך אינו מזוהה במערכת. ניתן להתחבר לרשימות השמעה אישיות מטלפון מזוהה בלבד",
                    "M1360.wav": "ברוכים הבאים לרשימת ההשמעה האישית שלכם. רשימת ההשמעה שלכם ריקה, ניתן להוסיף לרשימה במהלך האזנה בתכני המערכת.",
                    "M1361.wav": "ברוכים הבאים לרשימת ההשמעה האישית שלכם. להפעלת רשימת ברירת המחדל הקישו 1 או המתינו להפעלת רשימה אחרת הקישו 2 להגדרת רשימת השמעה ברירת המחדל הקישו 3 להגדרת צורת ההפעלה וההגדרות נוספות בשלוחה הקישו 4 לחזרה הקישו כוכבית",
                    "M1362.wav": "רשימת השמעה זו ריקה אנא בחרו רשימה אחרת",
                    "M1363.wav": "רשימת השמעה ברירת מחדל שלכם היא רשימה מספר",
                    "M1364.wav": "לאישור וחזרה הקישו 1 לשינוי הקישו 2",
                    "M1365.wav": "אנא הקישו את הרשימה אותה ברצונכם להגדיר כברירת מחדל וסולמית לסיום.",
                    "M1366.wav": "הגדרתם בהצלחה לרשימת ברירת מחדל את",
                    "M1367.wav": "אנא הקישו את מספר רשימת ההשמעה וסולמית לסיום",
                    "M1368.wav": "לא ניתן להקיש מקש כוכבית",
                    "M1369.wav": "להגדרת מיקום תחילת הפעלת הרשימה הקישו 1 לשינוי שם השלוחה הקישו 2 להעברת השמעה זו לרשימת השמעה חדשה אחרת הקישו 3 להגדרת השמעה זו כהשמעת ברירת מחדל הקישו 4 למחיקת כל רשימת השמעה זו הקישו 5 ליציאה הקישו כוכבית",
                    "M1370.wav": "האם הנכם בטוחים? לאישור מחיקת כל רשימת השמעה זו הקישו 1",
                    "M1371.wav": "הרשימה נמחקה בהצלחה",
                    "M1372.wav": "אנא הקישו את מספר הרשימה החדשה להעברה וסולמית לסיום",
                    "M1373.wav": "רשימת השמעה כבר קיימת אנא בחרו רשימה אחרת",
                    "M1374.wav": "רשימת ההשמעה הועברה בהצלחה",
                    "M1375.wav": "ההפעלה בשלוחה זו מוגדרת כ...",
                    "M1376.wav": "הפעלה מהקובץ שצורף אחרון",
                    "M1377.wav": "הפעלה מהקובץ שצורף ראשון",
                    "M1378.wav": "הפעלה בסדר אקראי",
                    "M1379.wav": "להפעלה מהקובץ שצורף ראשון הקישו 1 להפעלה מהקובץ שצורף אחרון הקישו 2 להפעלה בסדר אקראי הקישו 3 לביטול ויציאה הקישו כוכבית",
                    "M1380.wav": "הגדרתם בהצלחה",
                    "M1381.wav": "מחיקת ההשמעה. האם הנכם בטוחים? לאישור המחיקה הקישו 1",
                    "M1382.wav": "מחיקת ההשמעה התבצעה בהצלחה",
                    "M1383.wav": "שמיעה חוזרת 0 לפרטי ההשמעה הקישו 1 לשיתוף ההשמעה עם רשימת השמעה נוספת הקישו 2 להעברת השמעה זו לרשימת השמעה אחרת הקישו 3 למחיקת השמעה זו הקישו 4 לשיתוף ההשמעה זו עם קבוצות ומערכות תכנים אחרות הקישו 5",
                    "M1384.wav": "אנא הקישו את מספר רשימת ההשמעה להעברה וסולמית לסיום",
                    "M1385.wav": "האם הנכם בטוחים? לאישור מחיקת השמעה זו מרשימת ההשמעה הקישו 1",
                    "M1386.wav": "ההשמעה נמחקה בהצלחה",
                    "M1387.wav": "שמיעה חוזרת 0 לפרטי ההשמעה הקישו 1 לשיתוף ההשמעה עם רשימת השמעה נוספת הקישו 2 לשיתוף ההשמעה זו עם קבוצות ומערכות תכנים אחרות הקישו 5",
                    "M1388.wav": "לא ניתן להעביר השמעה בהפעלת רשימת השמעה של שלוחה שלמה, במקום זאת, ניתן לשתף.",
                    "M1389.wav": "לא ניתן למחוק השמעה בהפעלת רשימת השמעה של שלוחה שלמה",
                    "M1390.wav": "לאפשרויות האזנה הקישו כוכבית",
                    "M1391.wav": "לשמיעה חוזרת הקישו סולמית לשמירת ההשמעה ברשימת ההשמעות האישיות שלכם הקישו 1 לדירוג ההשמעה הקישו 2 לשיתוף השמעה זו עם קבוצות ומערכות תכנים אחרות הקישו 3 לתגובה על השמעה זו הקישו 4 להנמכת עוצמת השמע הקישו 5 להגברת עוצמת השמע הקישו 6 להפעלת כל שלוחה זו בסדר אקראי הקישו 7 לשמיעת פרטי הקובץ ואפשרויות הקשה הקישו 8 למעבר לקובץ אקראי הקישו 9 לניהול ההשמעה על ידי מנהל הקישו 0 לחזרה להשמעה הקישו כוכבית או המתינו",
                    "M1392.wav": "אין אישור להעברת הקובץ",
                    "M1393.wav": "אנא הקישו את מספר המערכת להעתקת הקובץ",
                    "M1394.wav": "הקובץ הועתק בהצלחה",
                    "M1395.wav": "חלה שגיאה בהעתקת הקובץ",
                    "M1396.wav": "אנא הקישו את מספר השלוחה לשיתוף ניתן לשתף רק לתיקיות של השמעת תכנים בלבד לביטול השיתוף הקישו כוכבית וסולמית",
                    "M1397.wav": "השלוחה שבחרתם אינה קיימת או שאינה של השמעת קבצים",
                    "M1398.wav": "לא ניתן להקליט תגובה בשלוחה זו.",
                    "M1399.wav": "תגובתך התקבלה בהצלחה",
                    "M1400.wav": "תגובתך התקבלה בהצלחה והועברה לאישור המנהל",
                    "M1401.wav": "לא ניתן להקליט תגובה ללא זיהוי טלפוני, אנא צלצלו מספר מזוהה",
                    "M1402.wav": "אנא הקליטו את תגובתכם לאחר השמע הצליל, לסיום הקישו סולמית",
                    "M1403.wav": "יש לך...",
                    "M1404.wav": "תגובות ממתינות לאישור",
                    "M1405.wav": "אין תגובות ממתינות לאישור",
                    "M1406.wav": " לשמיעה חוזרת הקישו 0 לאישור התגובה הקישו 1 למחיקת התגובה הקישו 2 לפרטי התגובה הקישו 3 לדילוג והחלטה במועד מאוחר יותר הקישו 4 ליציאה הקישו כוכבית.",
                    "M1407.wav": "להשמעה הבאה (X ,תגובות להאזנה הקישו..)",
                    "M1408.wav": "תגובות, להאזנה הקישו כוכבית ארבע",
                    "M1410.wav": "עדין אין תגובות, להקלטת תגובה הקישו 1 להמשך הקישו 9 או המתינו",
                    "M1411.wav": "יש (X תגובות)",
                    "M1412.wav": "(יש X) תגובות",
                    "M1413.wav": "הקופונים נגמרו.",
                    "M1414.wav": "אין כרגע קופונים לחלוקה",
                    "M1415.wav": "הקופון שלך הוא",
                    "M1416.wav": "לסיום הקישו 1. לשמיעת הקופון פעם נוספת הקישו 2.",
                    "M1417.wav": "הסרתם בהצלחה את הטלפון שלכם מרשימת התפוצה",
                    "M1418.wav": "הוספתם בהצלחה את הטלפון שלכם לרשימת התפוצה",
                    "M1419.wav": "אנא הקישו הסכום לחיוב",
                    "M1420.wav": "שקלים חדשים",
                    "M1421.wav": "הסכום חייב להיות גדול מ 0 שקלים, אנא נסו שנית",
                    "M1422.wav": "אנא הקישו את מספר כרטיס האשראי משמאול לימין ובסיום הקישו סולמית ליציאה הקישו כוכבית וסולמית",
                    "M1423.wav": "תוקף הכרטיס שגוי - יש להקיש תוקף ב4 ספרות חודש ב2 ספרות ושנה ב2 ספרות",
                    "M1424.wav": "אנא הקישו את תוקף הכרטיס בארבע ספרות",
                    "M1425.wav": "קיימת שגיאת התחברות עם השרת, אנא נסו מחדש בעוד מספר דקות, תודה",
                    "M1426.wav": "העיסקה נדחתה סטטוס סירוב",
                    "M1428.wav": "אנא הקישו את 3 הספרות בגב הכרטיס",
                    "M1429.wav": "אנא הקישו את מספר תעודת הזהות של בעל הכרטיס ובסיום הקישו סולמית",
                    "M1430.wav": "העיסקה התקבלה בהצלחה",
                    "M1431.wav": "אישור מספר",
                    "M1432.wav": "לשמיעה חוזרת של מספר האישור הקישו 1 לסיום הרכישה והמשך הקישו 2",
                    "M1433.wav": "אין שם משתמש",
                    "M1434.wav": "אין מספר מסוף",
                    "M1435.wav": "אין סיסמת מסוף",
                    "M1436.wav": "אנא הקישו את מספר התשלומים, ניתן לחלק עד ל",
                    "M1437.wav": "תשלומים",
                    "M1438.wav": "כאשר התשלום הראשון יהיה בגובה של ..",
                    "M1439.wav": "כמות התשלומים אינה תקינה",
                    "M1440.wav": "אנא הקש את המפתח שלך וסולמית לסיום",
                    "M1441.wav": "המפתח שהוקש אינו קיים.",
                    "M1442.wav": "מפתח זה כבר סיים את מקסימום השימושים.",
                    "M1443.wav": "אנא הקישו את השיוך שלכם, לדילוג הקישו סולמית או המתינו",
                    "M1444.wav": "עד כה חולקו",
                    "M1445.wav": "ספרים",
                    "M1446.wav": "סיסמת הקלטות והפעלת שידור חי",
                    "M1447.wav": "נרשמת בהצלחה",
                    "M1448.wav": "פג תוקף השידור. לחידוש אנא פנה לשרות הלקוחות",
                    "M1449.wav": "ההגדרות לא הושלמו",
                    "M1450.wav": "שגיאה בהפעלת השידור",
                    "M1451.wav": "השידור כבר החל - לא ניתן להכנס לשידור פעיל",
                    "M1452.wav": "ההודעה הוקלטה בהצלחה",
                    "M1453.wav": "בשלוחה זו",
                    "M1454.wav": "השמעות",
                    "M1455.wav": "תגובות משלוחה",
                    "M1456.wav": "התגובה נכנסה בהצלחה",
                    "M1457.wav": "תגובה הבאה",
                    "M1458.wav": "התגובה נמחקה בהצלחה",
                    "M1459.wav": "לשמיעה חוזרת הקישו 0 למעבר להשמעה הבאה הקישו 1",
                    "M1460.wav": "אין מספרים לחיוג אנא הוסיפו מספרים לחיוג ונסו שנית",
                    "M1461.wav": "אין הודעה מוקלטת לשידור",
                    "M1462.wav": "הפעלת קמפיין",
                    "M1463.wav": "ברשותך",
                    "M1464.wav": "יחידות",
                    "M1465.wav": "ברשימת התפוצה שלכם ישנם",
                    "M1466.wav": "מספרי טלפון לחיוג",
                    "M1467.wav": "עבור קמפיין זה תחויב ב",
                    "M1468.wav": "ההודעה לשידור היא",
                    "M1469.wav": "לאישור הפעלת הקמפיין הקישו 1, לחזרה לתפריט הקישו 2",
                    "M1470.wav": "לקוח יקר הקמפיין שביקשת להפעיל כבר פועל במערכת ועדיין לא הסתיים, האם אתה בטוח שברצונך להפעיל קמפיין נוסף? להפעלת קמפין נוסף הקישו 1 אחרת הקישו 2",
                    "M1471.wav": "יתרת היחידות החדשה היא",
                    "M1472.wav": "הקמפיין מופעל כעת",
                    "M1473.wav": "ההשמעה אותה שמעת לאחרונה, בתיקייה ...XXX",
                    "M1474.wav": "האזנה מספר",
                    "M1475.wav": "עצרת בדקה",
                    "M1476.wav": "אורך ההשמעה",
                    "M1477.wav": "דקות",
                    "M1478.wav": "למעבר למשאיר ההודעה הקישו 1, לשמיעה חוזרת של פרטי ההודעה, הקישו 2, לחזרה להודעות הקישו *",
                    "M1479.wav": "לא ניתן לבצע את השיחה. אנא פנה למנהל המערכת.",
                    "M1480.wav": "למעבר למשאיר ההודעה הקישו 1,לחזרה להודעות הקישו *",
                    "M1481.wav": "לשמיעה חוזרת של פרטי ההודעה, הקישו 1, לחזרה להודעות הקישו *",
                    "M1482.wav": "הוקלטה",
                    "M1483.wav": "ביום",
                    "M1484.wav": "אתמול",
                    "M1485.wav": "בשעה",
                    "M1486.wav": "הודעה ממספר טלפון",
                    "M1487.wav": "אין פרטים על ההודעה",
                    "M1488.wav": "היום",
                    "M1489.wav": "הועברה ביום",
                    "M1490.wav": "ו..",
                    "M1491.wav": "דקות",
                    "M1492.wav": "לא מעודכן תאריך להודעה זו",
                    "M1493.wav": "לא מעודכנת שעה להודעה זו",
                    "M1494.wav": "להודעה זו לא מעודכן מספר מקליט ההודעה",
                    "M1495.wav": "ב..",
                    "M1496.wav": "יתרת היחידות שברשותך אינה מאפשרת את הוצאת הקמפיין",
                    "M1497.wav": "הפעלת הקמפין בוטלה",
                    "M1498.wav": "אנא הקישו את מספר השורה המבוקש לבחירת כסא אקראי הקישו 0 וסולמית לשמיעת כל המקומות הפנויים ברצף הקישו כוכבית וסולמית ליציאה הקישו סולמית.",
                    "M1499.wav": "אין כסאות לבחירה בשורה זו",
                    "M1500.wav": "בשורה...",
                    "M1501.wav": "יש",
                    "M1502.wav": "כסאות זמינים",
                    "M1503.wav": "אנא הקישו את מספר הכסא המבוקש, לבחירת כסא אקראי הקישו 0 וסולמית ליציאה הקישו סולמית.",
                    "M1504.wav": "הכסאות הזמינים הם:",
                    "M1505.wav": "כסא זה אינו זמין למכירה",
                    "M1506.wav": "בחרת שורה",
                    "M1507.wav": "כסא",
                    "M1508.wav": "הסכום לתשלום על הכסא הינו:",
                    "M1509.wav": "לשמירת המקום הקישו 1 לבחירת כסא אחר הקישו 2",
                    "M1510.wav": "הכסא נשמר עד לסיום השיחה ומקסימום ל20 דקות",
                    "M1511.wav": "(כסא...) עדיין פנוי, באם ברצונכם לרכוש גם אותו הקישו 1 לסיום ומעבר לתשלום הקישו 2",
                    "M1512.wav": "שגיאה בשמירת הכסא",
                    "M1513.wav": "סיום הזמנה",
                    "M1514.wav": "הוזמנו (X כסאות)",
                    "M1515.wav": "(הוזמנו X) כסאות",
                    "M1516.wav": "הסך הכולל לתשלום",
                    "M1517.wav": "להלן הפירוט",
                    "M1518.wav": "שורה..",
                    "M1519.wav": "מחיר",
                    "M1520.wav": "הסך הכולל לתשלום",
                    "M1521.wav": "שקלים",
                    "M1522.wav": "לאישור ההזמנה הקישו 1 לביטול ההזמנה הקישו 2",
                    "M1523.wav": "ההזמנה בוטלה שלום ותודה",
                    "M1524.wav": "לתשלום בכרטיס אשראי הקישו 1 לתשלום בהוראת קבע הקובעה במוסד הקישו 2 להקשת קופון הקישו 3",
                    "M1525.wav": "המקומות נרכשו בהצלחה",
                    "M1526.wav": "הגעת למקסימום כרטיסים הניתן לשמור עבורך הינך מועבר לתשלום",
                    "M1527.wav": "כבר יש כסאות קנויים על שמך לשמיעת הפרטים הקישו 1 להזמנה נוספת הקישו 2 ליציאה הקישו כוכבית",
                    "M1528.wav": "כבר קנית את מקסימום כסאות האפשרי עבורך, לא ניתן להזמין כסאות נוספים",
                    "M1529.wav": "נקנו... (כסאות)",
                    "M1530.wav": "לסיום ומעבר לתשלום הקישו 1 לקניית כסא נוסף סמוך הקישו 2 לבחירת כסא נוסף בשורה זו הקישו 3 לבחירת מקום בשורה אחרת הקישו 4",
                    "M1531.wav": "...אינו זמין למכירה אנא נסו אפשרויות נוספות",
                    "M1532.wav": "אין כסא אקראי לבחירה בשורה זו אנא בחר כסא מהתפריט",
                    "M1533.wav": "העיסקה נקלטה בהצלחה",
                    "M1534.wav": "חובה לודא מול הנציג תוך 24 שעות שהוראת הקבע נקלטה ותקינה, אחרת הרישום יבוטל",
                    "M1535.wav": "חובה לודא מול הנציג תוך 24 שעות שהקופון נקלט ותקין אחרת הרישום יבוטל",
                    "M1536.wav": "אנא הקישו את קוד הקופון שברשותכם וסולמית לסיום",
                    "M1537.wav": "לסיום ומעבר לתשלום הקישו 1 לבחירת מקום נוסף הקישו 2",
                    "M1538.wav": "הקופון שהוקש שגוי",
                    "M1539.wav": "אין הרשאה לחיוב בהוראת קבע",
                    "M1540.wav": "עניתם בהצלחה",
                    "M1541.wav": "תשובתכם שגויה אנא נסו בפעם הבאה",
                    "M1542.wav": "שגיאה בהפעלת השאלה",
                    "M1543.wav": "שגיאה בקבלת תשובה נכונה",
                    "M1549.wav": "אנא הקליטו את השם שעבורו אתם רוכשים את המקומות וכן את הכתובת למשלוח דואר שלו, בסיום ההקלטה הקישו סולמית",
                    "M1550.wav": "אם ברצונכם שמעתה כל שלוחה אליה תיכנסו תאפשר לכם לבחור איזו השמעה להפעיל, הקישו 1. אם ברצונכם לבטל בחירה זו, כך שבכל השלוחות לא יתאפשר לכם לבחור קובץ, אלא השלוחה תופעל בצורה רגילה, הקישו 2.",
                    "M1551.wav": "ההגדרה עודכנה בהצלחה מעתה, בשיחה זו, יתאפשר לבחור קובץ להשמעה, בכל שלוחה של השמעת קבצים.",
                    "M1552.wav": "ההגדרה עודכנה בהצלחה מעתה, בשיחה זו, כל השלוחות יופעלו בצורה רגילה.",
                    "M1553.wav": "לאישור ההקלטה הקישו 1, לשמיעה הקישו 2 להקלטה מחדש 3",
                    "M1554.wav": "הפרטים נקלטו בהצלחה",
                    "M1555.wav": "למחיקת ההודעה הקישו 1 לשינוי ההודעה הקישו 2 לחזרה הקישו כוכבית.",
                    "M1556.wav": "הנכם מועברים להקלטת הקובץ מחדש. אנא הקליטו את הודעתכם לאחר הצליל, ובסיום הקישו #.",
                    "M1557.wav": "הקלטת הקובץ מחדש הסתיימה בהצלחה.",
                    "M1558.wav": "הודעה לפני שמיעת הודעת סוג המפתח",
                    "M1559.wav": " לשינוי הקלטה זו הקישו 8 להקלטת קובץ חדש לשלוחה זו הקישו 7 שלמיעה חוזרת הקישו 9 למעבר להודעה הבאה הקישו 1 או המתינו למחיקת הקובץ הקישו 2 לשכפול הקובץ 3 להעברת הקובץ 4 להוספת כותרת לשיעור הקישו 5 לשמיעת פרטי ההודעה הקישו 6 להקלטת קובץ חדש לשלוחה זו הקישו 7 לשינוי הקלטה זו הקישו 8",
                    "M1560.wav": "שעון נוכחות לדיווח על כניסה הקישו 1 לדיווח על יציאה הקישו 2 לחזרה לתפריט קודם הקישו כוכבית",
                    "M1561.wav": "דיווח כניסה התבצע בהצלחה",
                    "M1562.wav": "דיווח כניסה כבר התבצע בהצלחה",
                    "M1563.wav": "לחזרה לתפריט הקישו כוכבית לדיווח מאוחר על היציאה הקישו 1 לדיווח על כניסה נוספת ללא דיווח על היציאה הקישו 2",
                    "M1564.wav": "דיווח יציאה התבצע בהצלחה",
                    "M1565.wav": "דיווח יציאה כבר התבצע בהצלחה",
                    "M1566.wav": " לחזרה לתפריט הקישו כוכבית לדיווח מאוחר על הכניסה הקישו 1 לדיווח על יציאה נוספת ללא דיווח על כניסה הקישו 2",
                    "M1567.wav": "לא ניתן לבצע יציאה ללא כניסה אנא דווחו על כניסה ולאחר מכן יציאה",
                    "M1568.wav": "סך המשמרת הינו",
                    "M1569.wav": "שעות",
                    "M1570.wav": "דיווח מאוחר על כניסה שימו לב: לאישור סופי של הנתונים יש לגשת למעסיק שלכם הנתונים נשלחים עם סימון של דיווח מאוחר עם שעת הדיווח לביטול דיווח הקישו כוכבית וסולמית לדיווח מאוחר על כניסה מהיום הקישו ב4 ספרות את השעה והדקה לדוגמא לדיווח על כניסה בשעה שמונה וחמשה הקישו 0805 לדיווח מאוחר על כניסה ביום אחר הקישו 1 וסולמית",
                    "M1571.wav": "השעה אינה תקינה",
                    "M1572.wav": "דיווח מאוחר על כניסה התבצע בהצלחה",
                    "M1573.wav": "דיווח יציאה ללא דיווח כניסה התבצע בהצלחה",
                    "M1574.wav": "שים לב - על מנת להשלים את הפירוט עליך לגשת למעסיק",
                    "M1575.wav": "התאריך אינו תקין",
                    "M1576.wav": " דיווח מאוחר על כניסה בתאריך אחר אנא הקישו ב4 ספרות את היום והחודש של הדיווח לדוגמא לדיווח על כניסה ב19 לספטמבר הקישו תשע עשרה אפס תשע לביטול דיווח הקישו כוכבית וסולמית",
                    "M1577.wav": "חודש..",
                    "M1578.wav": "לא ניתן להקיש תאריך עתידי",
                    "M1579.wav": "אנא הקישו ב4 ספרות את השעה והדקה לדוגמא לדיווח על כניסה בשעה שמונה וחמשה הקישו 0805",
                    "M1580.wav": " שימו לב! לסיום הטיפול בכניסה ללא יציאה עליך לגשת למעביד דיווח כניסה נוספת התבצע בהצלחה",
                    "M1581.wav": "דיווח מאוחר על יציאה שימו לב: לאישור סופי של הנתונים יש לגשת למעסיק שלכם הנתונים נשלחים עם סימון של דיווח מאוחר עם שעת הדיווח לביטול דיווח הקישו כוכבית וסולמית לדיווח מאוחר על יציאה מהיום הקישו ב4 ספרות את השעה והדקה לדוגמא לדיווח על יציאה בשעה ארבע אחר הצהרים הקישו 1600 לדיווח מאוחר על יציאה ביום אחר הקישו 1 וסולמית",
                    "M1582.wav": "לתשומת לבכם סיכום המשמרת הינו על סמך דיווח כניסה מאוחר",
                    "M1583.wav": "שים לב! לסיום הטיפול עליך לגשת למעביד דיווח מאוחר של יציאה התקבל בהצלחה",
                    "M1584.wav": "דיווח מאוחר על יציאה בתאריך אחר אנא הקישו ב4 ספרות את היום והחודש של הדיווח לדוגמא לדיווח על יציאה ב19 לספטמבר הקישו תשע עשרה אפס תשע לביטול דיווח הקישו כוכבית וסולמית",
                    "M1585.wav": "אנא הקישו ב4 ספרות את השעה והדקה לדוגמא לדיווח על יציאה בשעה ארבע אחר הצהרים הקישו 1600",
                    "M1586.wav": "לא ניתן להקיש זמן עתידי",
                    "M1587.wav": "עדיין אין כסאות בהזמנה זו",
                    "M1588.wav": "לבחירת כסא נוסף בשורה זו הקישו 1 לבחירת כסא נוסף בשורה אחרת הקישו 2 לסיום ומעבר לתשלום הקישו 3",
                    "M1590.wav": "לימוד דף גמרא",
                    "M1591.wav": "נותרו",
                    "M1592.wav": "דפים לסיום מחזור מספר",
                    "M1593.wav": "של השס",
                    "M1594.wav": "לקבלת דף ללימוד הקישו 1, לחזרה הקישו 2",
                    "M1595.wav": "הדף שנפל בחלקך להשלמת סיום השס הוא",
                    "M1596.wav": "דף",
                    "M1597.wav": "במסכת",
                    "M1598.wav": "עד דף",
                    "M1599.wav": "עיסקה זו תחוייב בפריסה של",
                    "M1600.wav": "אנא הקש מספר תשלומים וסולמית לסיום",
                    "M1601.wav": "לא ניתן לבחור יותר מ36 תשלומים",
                    "M1602.wav": "בעיסקה זו ניתן עד",
                    "M1603.wav": "הסכום לכל תשלום לא יכול להיות קטן מעשרה שקלים",
                    "M1604.wav": "אין סוג סליקה",
                    "M1605.wav": "הקש את הספרות כעת",
                    "M1607.wav": "אין מענה משרת API",
                    "M1609.wav": "לא מוגדר לינק",
                    "M1610.wav": "לאחר הצליל נא לומר או להקיש את שם השלוחה המבוקשת לחזרה לתפריט קודם אמרו חזור או הקישו סולמית",
                    "M1611.wav": "דיבור לא ברור",
                    "M1612.wav": "אין הגדרה לבקשה",
                    "M1613.wav": "לא זוהה דיבור",
                    "M1615.wav": "לאחר הצליל אנא אמרו את שם המוצר או הקטגוריה המבוקשת",
                    "M1616.wav": "בקשתכם לקבלת מספר אישי למערכת זו נקלטה בהצלחה. מיד יופיע לכם המספר על צג הטלפון. כעת תוכלו לחייג למערכת זו, דרך המספר שקיבלתם.",
                    "M1617.wav": "לצערנו לא קיים כעת מספר אישי למספר שלכם",
                    "M1618.wav": "הכמות ממוצר זה אזלה אנא נסה שוב במועד אחר",
                    "M1619.wav": "אנא הקליטו את השם שעבורו התבצעה ההזמנה וכן את הכתובת למשלוח דואר בסיום ההקלטה הקישו סולמית",
                    "M1620.wav": "אנא הקישו את מספר המוצר לסיום הזמנה ומעבר לתשלום הקישו אפס וסולמית ליציאה הקישו כוכבית וסולמית",
                    "M1621.wav": "מספר מוצר זה אינו מוגדר",
                    "M1622.wav": "המחיר למוצר זה",
                    "M1623.wav": "להזמנת המוצר הקישו 1 לחזרה הקישו 2",
                    "M1624.wav": "אנא הקישו את הכמות להזמנה ממוצר זה",
                    "M1625.wav": "הכמות לא יכולה להיות אפס",
                    "M1626.wav": "הכמות היא",
                    "M1627.wav": "הסך הכולל לתשלום על מוצר זה",
                    "M1628.wav": "לאישור הזמנת המוצר הקישו 1 לביטול הקישו 2 לתיקון הכמות הקישו 2 לביטול ההזמנה ממוצר זה הקישו 3",
                    "M1629.wav": "כבר הזמנת",
                    "M1630.wav": "יחידות ממוצר זה",
                    "M1631.wav": "הזמנת המוצר נקלטה ונשמרה עד לסיום השיחה לסיום ומעבר לתשלום הקישו 1 להמשך קניה הקישו 2",
                    "M1632.wav": "סיום הזמנה",
                    "M1633.wav": "הוזמנו",
                    "M1634.wav": "מוצרים",
                    "M1635.wav": "שהם",
                    "M1636.wav": "פריטים",
                    "M1637.wav": "הסך הכולל לתשלום עבור כלל המוצרים",
                    "M1638.wav": "שקלים",
                    "M1639.wav": "לאישור ההזמנה הקישו 1 לביטול ההזמנה הקישו 2",
                    "M1640.wav": "להלן פירוט ההזמנה",
                    "M1641.wav": "מוצר",
                    "M1642.wav": "מחיר",
                    "M1643.wav": "הוזמנו",
                    "M1644.wav": "פריטים",
                    "M1645.wav": "תשלום כולל עבור מוצר זה",
                    "M1646.wav": "לשמיעת הפירוט אנא המתינו",
                    "M1647.wav": "לתשלום בכרטיס אשראי הקישו 1 לתשלום סוכנים הקישו 4",
                    "M1648.wav": "סוכן לא מאושר",
                    "M1649.wav": "אנא הקישו את מספר הסוכן שלכם וסולמית לסיום",
                    "M1650.wav": "ההזמנה התבצעה בהצלחה",
                    "M1651.wav": "אישור מספר...",
                    "M1652.wav": "ההזמנה בוטלה שלום ותודה",
                    "M1653.wav": "אין מוצרים בסל הקניות שלך",
                    "M1654.wav": "לפניכם",
                    "M1655.wav": "מוצרים לבחירה",
                    "M1656.wav": "אין מוצרים לבחירה",
                    "M1659.wav": "להזמנה ממוצר זה הקישו1 למעבר למוצר הבא הקישו 2 לסיום הזמנה ומעבר לתשלום הקישו 3 או אפס לחזרה לתפריט קודם הקישו 4 או סולמית",
                    "M1668.wav": "לתשומת ליבכם, דמי משלוח עבור הזמנה זו בסך של..",
                    "M1669.wav": "לקבלת דף גמרא נוסף הקישו 1, לחזרה לתפריט הקישו 2",
                    "M1670.wav": "לקבלת פרק נוסף הקישו 1, לחזרה לתפריט הקישו 2",
                    "M1671.wav": "לקבלת מספר אישי לטלפון אשר ממנו אתם מחייגים, הקישו 1, לשליחת מספר אישי לטלפון אחר, הקישו 2, לדיווח על מספר שנחסם, הקישו 3.",
                    "M1672.wav": "אנא הקישו את מספר הטלפון שאליו ברצוכם לשלוח מספר אישי של מערכת זו.",
                    "M1673.wav": "הפעולה בוצעה בהצלחה, מספר אישי למערכת זו, נשלח בהצלחה למספר הטלפון שהקשתם.",
                    "M1674.wav": "לצערנו לא ניתן לשלוח כעת מספר אישי, למספר הטלפון שהוקש.",
                    "M1683.wav": "דמי משלוח - באם ברצונכם לאסוף את המוצר בעצמכם ללא תוספת דמי משלוח הקישו 2 להמשך כולל דמי משלוח בסך",
                    "M1684.wav": "שקלים הקישו 1",
                    "M1686.wav": "קטגוריה זו הסתיימה, למעבר לתשלום הקישו 1, לחזרה לתפריט קודם הקישו 2",
                    "M1687.wav": "אפשרות לא מאושרת",
                    "M1688.wav": "המלאי הזמין ממוצר זה כרגע הוא",
                    "M1689.wav": "אנא בחר כמות הקיימת במלאי",
                    "M1691.wav": "לאחר הצליל אנא הקליטו את ההודעה למנהל המערכת, ההודעה תשלח במידה והעיסקה תבוצע בהצלחה, בסיום ההקלטה הקישו סולמית",
                    "M1692.wav": "ברירת מחדל זה גינגל של ימות המשיח (הודעה בצד העונה לפני תחילת השיחה בניתוב שיחה)",
                    "M1693.wav": "שיחה זו מועברת אליכם באמצעות הפלטפורמה הטכנולגית של ימות המשיח, לקבלת השיחה הקישו 1, לדחיית השיחה הקישו 2",
                    "M1694.wav": "לשמיעה חוזרת של מספר האישור הקישו 1 לסיום הקישו 2",
                    "M1697.wav": "שימו לב, לבקשתכם, נחסמתם מלקבל צינתוקים ממערכת זו. ולכן, לא ניתן לשלוח לכם כעת מספר אישי.",
                    "M1698.wav": "אם ברצונכם לאשר קבלת צינתוקים מהמערכת, ולקבל מספר אישי, הקישו 1. לביטול ויְצִיאָה, הקישו 2, או הַמְתינו. רשימת ההודעות של תחבורה ציבורית:",
                    "M1700.wav": "הודעה שתושמע ראשונה בשלוחה",
                    "M1701.wav": "הקווים העוברים בתחנה הם",
                    "M1702.wav": "בשעה",
                    "M1703.wav": "קו",
                    "M1704.wav": "אנא הקישו מספר תחנה",
                    "M1705.wav": "יגיע בעוד",
                    "M1706.wav": "דקות",
                    "M1707.wav": "no_such_station",
                    "M1708.wav": "no_line_is_expected",
                    "M1709.wav": "query_error",
                    "M1710.wav": "יגיע בעוד פחות מדקה",
                    "M1711.wav": "א'",
                    "M1712.wav": "שתי",
                    "M1713.wav": "אנא הקישו מספר אוטובוס",
                    "M1714.wav": "this_line_is_not_expected_during_hour",
                    "M1715.wav": "ונמצא בתחנה",
                    "M1716.wav": "ונמצא בתחנת המוצא",
                    "M1717.wav": "לכיוון",
                    "M1718.wav": "אין מיקום משוער",
                    "M1719.wav": "הנך פעם ראשונה במערכת, ועדיין אין לך חיפושים שמורים.",
                    "M1720.wav": "אנא הקישו יום בשבוע",
                    "M1722.wav": "ל",
                    "M1723.wav": "הקישו",
                    "M1724.wav": "נבחר מפעיל שגוי",
                    "M1725.wav": "no_such_bus",
                    "M1726.wav": "אנא בחר מפעיל מהרשימה",
                    "M1727.wav": "נבחר יום שגוי",
                    "M1728.wav": "אנא בחר מסלול מהרשימה",
                    "M1729.wav": "נבחר מסלול שגוי",
                    "M1730.wav": "אנא הקישו שעה רצויה בין 0 ל23 ",
                    "M1732.wav": "נבחרה שעה שגויה",
                    "M1733.wav": "נבחר מספר דקות שגוי",
                    "M1734.wav": "הקו יעבור בתחנה",
                    "M1797.wav": "אין הגדרה לבקשה",
                    "M1798.wav": "האם לא קיבלתם את שיחת האימות?",
                    "M1799.wav": "לשליחה מחודשת של שיחת אימות הקישו 1, לחזרה להקשת הארבע ספרות האחרונות הקישו 2. שימו לב, כדי לקבל את שיחת האימות עליכם לוודא שאופציית שיחה ממתינה פועלת אצלכם. ניתן לבדוק זאת בהגדרות הטלפון או לפנות לחברת התקשורת על מנת לוודא או להפעיל את האופציה.",
                    "M1800.wav": "אנא הקישו את סיסמת הניהול וסולמית לסיום",
                    "M1801.wav": "אחד או יותר מהנתונים שהקשת שגוי",
                    "M1802.wav": "לצורך אימות מספר הטלפון שלכם, תקבלו כעת שיחה ממספר מסויים, יש לזכור את ארבעת הספרות האחרונות של המספר, ולהקיש אותם לאחר קבלת הצינתוק.",
                    "M1803.wav": "אנא הקישו את ארבעת הספרות האחרונות של מספר הטלפון שקיבלתם ממנו שיחה כעת",
                    "M1804.wav": "אחד או יותר מהנתונים שהוקשו שגויים",
                    "M1805.wav": "חלה שגיאה באימות מספר הטלפון",
                    "M1806.wav": "אימות מספר הטלפון בוצע בהצלחה",
                    "M1807.wav": "מספר החברים בקבוצה הוא",
                    "M1808.wav": "לשמיעת מספר הטלפון של מנהל הקבוצה הקישו 1, לבדיקה האם מספר מסויים חבר בקבוצה הקישו 2, לשמיעת כל המספרים החברים בקבוצה ברצף הקישו 3.",
                    "M1809.wav": "מנהל הקבוצה הוא:",
                    "M1810.wav": "מִסְפָּר הַטֶּלֶפוֹן שהוקש אֵינֶנּוּ תַּקִּין, אָנָּא נַסּוּ שֵׁנִית.",
                    "M1811.wav": "כבר קיים בקבוצה שלך.",
                    "M1812.wav": "כבר קיים בקבוצה שלך במצב חסום.",
                    "M1813.wav": "איננו קיים בקבוצה שלך",
                    "M1814.wav": "אנא הקישו את מספר הטלפון ולסיום הקישו סולמית.",
                    "M1815.wav": "הוצאתם מחדר הועידה",
                    "M1816.wav": "הנך מועבר לחדר הועידה",
                    "M1817.wav": "צליל כניסת משתתף לחדר הועידה (ברית מחדל שקט)",
                    "M1818.wav": "צליל יציאת משתתף מחדר הועידה (ברירת מחדל שקט)",
                    "M1823.wav": "לא הוגדר כמות עמודים בפרק זה",
                    "M1824.wav": "הדף שיצא לך ללמוד הוא דף",
                    "M1825.wav": "עמוד",
                    "M1826.wav": "בפרק",
                    "M1827.wav": "לקבלת עמוד נוסף הקישו 1, לחזרה לתפריט הקישו 2 או המתינו",
                    "M1828.wav": "שם החלל לתפילה הוא",
                    "M1829.wav": "דולרים ארצות הברית",
                    "M1831.wav": "הזמנת המוצר נקלטה ונשמרה עד לסיום השיחה",
                    "M1832.wav": "יש",
                    "M1833.wav": "הזמנות מאושרות שבוצעו מזיהוי זה",
                    "M1834.wav": "עסקה מאושרת מספר",
                    "M1835.wav": "אישור מספר",
                    "M1836.wav": "כמות הפריטים שהוזמנה",
                    "M1837.wav": "הסך הכולל ששולם",
                    "M1838.wav": "לשמיעה חוזרת הקישו 1 לשמיעת העיסקה הבאה הקישו 2 לפירוט מלא של עיסקה זו הקישו 3 ליציאה הקישו כוכבית",
                    "M1839.wav": "אין הזמנות מאושרות ממספר זיהוי זה",
                    "M1840.wav": "סוף אישורים",
                    "M1842.wav": "לא הוגדר זמן להפעלת השידור",
                    "M1843.wav": "אין קובץ להפעלת השידור",
                    "M1844.wav": "השידור כבר הסתיים",
                    "M1845.wav": "השידור הסתיים כעת בהצלחה",
                    "M1847.wav": "השידור יחל בעוד...",
                    "M1848.wav": "להמתנה הקישו 1 ליציאה הקישו 2 או כוכבית",
                    "M1849.wav": "שעות",
                    "M1850.wav": "ו..",
                    "M1851.wav": "דקות",
                    "M1856.wav": "השעה אינה תקינה",
                    "M1857.wav": "התאריך אינו תקין",
                    "M1858.wav": "תעודת הזהות אינה תקינה",
                    "M1859.wav": "על פי רשומי המערכת כבר הכנסת בעבר את הפרטים אותם הכנסת עכשיו, לא ניתן להמשיך, שלום ותודה",
                    "M1860.wav": "במודול זה מחושב הסכום אותו אתם צריכים לטעון בפועל בשביל שלאחר אחוזי התוספת תגיעו לסכום המופיע בחנות. התוספת הינה על סך",
                    "M1861.wav": "אחוזים",
                    "M1862.wav": "אנא הקישו את הסכום המלא לתשלום המופיע בחנות לסימון נקודה הקישו כוכבית. לסיום הקישו סולמית. לדוגמא לסכום 35.90 שח הקישו : שלושים וחמש כוכבית תשעים וסולמית לסיום. ליציאה הקישו כוכבית וסולמית",
                    "M1863.wav": "לא הוגדרו אחוזים לחישוב",
                    "M1864.wav": "בקניה זו הנכם חוסכים",
                    "M1865.wav": "שקלים.",
                    "M1866.wav": "לרכישת מוצר זה, הסכום אותו תצטרכו לטעון בפועל בכרטיס הוא",
                    "M1867.wav": "כאשר לאחר תוספת של",
                    "M1868.wav": "אחוזים, יטען לכם בכרטיס סך של..",
                    "M1869.wav": "להקשת סכום נוסף הקישו 1 להמשך הקישו 2 או כוכבית לשמיעה חוזרת הקישו סולמית או המתינו",
                    "M1870.wav": "לבחירת המוצר אנא הקישו את הכמות",
                    "M1871.wav": "למעבר למוצר הבא הקישו כוכבית",
                    "M1872.wav": "למעבר לתשלום הקישו אפס",
                    "M1873.wav": "לחזרה הקישו כוכבית",
                    "M1874.wav": "בסיום הבחירה הקישו סולמית",
                    "M1875.wav": "לפירוט ההזמנה הקישו 3",
                    "M1907.wav": "שקלים",
                    "M1908.wav": "ו..",
                    "M1909.wav": "אגורות",
                    "M1910.wav": "מספר הטלפון שהוקש אינו תקין, אנא נסו שנית",
                    "M1911.wav": "ברכות",
                    "M1912.wav": "שבת",
                    "M1913.wav": "עירובין",
                    "M1914.wav": "פסחים",
                    "M1915.wav": "יומא",
                    "M1916.wav": "סוכה",
                    "M1921.wav": "ביצה",
                    "M1922.wav": "ראש השנה",
                    "M1923.wav": "תענית",
                    "M1924.wav": "מגילה",
                    "M1925.wav": "מועד קטן",
                    "M1926.wav": "חגיגה",
                    "M1931.wav": "יבמות",
                    "M1932.wav": "כתובות",
                    "M1933.wav": "נדרים",
                    "M1934.wav": "נזיר",
                    "M1935.wav": "סוטה",
                    "M1936.wav": "גיטין",
                    "M1937.wav": "קידושין",
                    "M1941.wav": "בבא קמא",
                    "M1942.wav": "בבא מציעא",
                    "M1943.wav": "בבא בתרא",
                    "M1944.wav": "סנהדרין",
                    "M1945.wav": "מכות",
                    "M1946.wav": "שבועות",
                    "M1947.wav": "עבודה זרה",
                    "M1948.wav": "הוריות",
                    "M1950.wav": "תמיד",
                    "M1951.wav": "זבחים",
                    "M1952.wav": "מנחות",
                    "M1953.wav": "חולין",
                    "M1954.wav": "ברכות",
                    "M1955.wav": "ערכין",
                    "M1956.wav": "תמורה",
                    "M1957.wav": "כריתות",
                    "M1958.wav": "מעילה",
                    "M1959.wav": "קנים",
                    "M1960.wav": "מידות",
                    "M1961.wav": "נידה",
                    "M1962.wav": "ההגדרות לא הושלמו",
                    "M1974.wav": "לא הוגדר מספר עסק",
                    "M1975.wav": "אין קובץ רשימת עסקים",
                    "M1976.wav": "אנא הקישו את הסכום בשקלים מלאים אותו שילמת, להזכירך ניתן להזין רק מה שכבר שולם ולא תשלום עתידי, הכל בכפוף לתקנון, לדוגמא במידה ושילמתם תשעים ותשע וחצי ₪ הקישו 99 וסולמית",
                    "M1977.wav": "לדירוג בעל המקצוע הקישו 1 או המתינו לדילוג הקש 2",
                    "M1978.wav": "עסק לא מופיע ברשימה",
                    "M1993.wav": "אנא הקש את מספר הזיהוי של הנמען וסולמית לסיום",
                    "M1994.wav": "לשמיעת התהילים בנוסח ספרד הקישו 1 או המתינו לשמיעת התהילים בנוסח אשכנז הקישו 2",
                    "M1996.wav": "(השמעת הודעה לפני השמעת המספר השגוי בשלוחה עם כניסה לפי הקשת מספר זיהוי אישי)",
                    "M2001.wav": "עד – ",
                    "M2154.wav": "הפקס נשלח בהצלחה",
                    "M2155.wav": "אנא הקישו את המִסְפָּר שאליו ברצונכם לשלוח את הפקס ובסיום הַקִּישו סולמית",
                    "M2156.wav": "לצערנו, קיימת שגיאה בשליחת הפקס. פרטי השגיאה הם",
                    "M2157.wav": "לצערנו, לא ניתַן לשלוח את הפקס, מפני שלא מוגדר מספר טלפון לשליחה",
                    "M2158.wav": "(קובץ ריק)",
                    "M2159.wav": "(קובץ ריק)",
                    "M2160.wav": "משימתך היא..",
                    "M2161.wav": "לאישור ביצוע המשימה הקישו 1 לחזרה הקישו כוכבית.",
                    "M2162.wav": "אישור ביצוע המשימה התקבל בהצלחה.",
                    "M2163.wav": "המשימות שעדיין לא בוצעו הם...",
                    "M2164.wav": "מספר זה כבר דיווח היום על ביצוע המשימה.",
                    "M2165.wav": "למספר טלפון זה לא הוקצו משימות",
                    "M2166.wav": "בקשתך התקבלה. בדקות הקרובות הדוח המבוקש ישלח אליך לדואר האלקטרוני המוגדר במערכת.",
                    "M2167.wav": "הקובץ אינו קיים",
                    "M2168.wav": "לצערנו, לא ניתַן לשלוח את הפקס, מפני שאין קובץ תקין לשליחה",
                    "M2181.wav": "אנא הקישו את המספר שנחסם, ובסיום, הַקישו סולמית",
                    "M2182.wav": "שימו לב, בשליחת דיווח, הנכם מאשרים קבלת צינתוקים ו\\או שיחות מאיתנו, על מנת לעדכן אתכם במספר חדש",
                    "M2183.wav": "לאישור, הקישו 1. לביטול ויְצִיאָה, הקישו 2, או הַמְתינו.",
                    "M2184.wav": "אנא בחרו את חברת התקשורת של הפלאפון שעבורו נחסם המספר. לפלאפון, הקישו 1. לסלקום, הקישו 2. לפרטנר אורנג', הקישו 3. לגולן טלקום, הקישו 4. להוט מובייל או מירס, הקישו 5. לרמי לוי, הקישו 6. לבזק, הקישו 7. לנטויז'ן, הקישו 8, לחברות אחרות, או אם לא ידוע לכם לאיזה חברת תקשורת משוייך המכשיר שלכם, הקישו 9, או המתינו.",
                    "M2185.wav": "הדיווח התקבל בהצלחה",
                    "M2186.wav": "הקלטת הודעות מערכת",
                    "M2187.wav": "אנא הקישו את שלוחת היעד וסולמית לסיום, לשלוחה פנימיות הקישו את הכתובת המלאה כאשר בין שלוחה לשלוחה הקישו כוכבית ולסיום הכתובת המלאה הקישו סולמית, לדוגמא לשלוחה אחת בתוך שלוחה אחת בתוך שלוחה שלוש הקישו שלוש כוכבית אחת כוכבית שלוש וסולמית לשלוחת הודעות ברירת המחדל הקישו כוכבית כוכבית וסולמית.",
                    "M2188.wav": "שימו לב ההקלטה בשלוחה זו תחליף את כל המקומות במערכת בהם מושמעת הודעה זו, אלא אם כן תשימו הודעה מיוחדת בתוך השלוחה הספציפית לאישור והמשך הקישו 1 לביטול וחזרה הקישו 2",
                    "M2189.wav": "אנא הקישו את מספר הודעת מערכת ב4 ספרות לחזרה לתפריט הקודם הקישו כוכבית וסולמית",
                    "M2190.wav": "אנא הקליטו את ההודעה המיוחדת שלכם לאחר הצליל ובסיום הקישו סולמית",
                    "M2191.wav": "ההקלטה מבוטלת",
                    "M2192.wav": "שלוחה ראשית",
                    "M2193.wav": "שלוחת הודעות ברירת מחדל",
                    "M2194.wav": "יצרתם בהצלחה הודעת מערכת בשלוחה...",
                    "M2195.wav": "הודעה מספר",
                    "M2198.wav": "המערכת מזהה כי כבר נרשמתם לא ניתן להירשם בשנית שלום ותודה",
                    "M2200.wav": "השיעורים באדיבות מפעל קביעותא ללימוד המשנה וההלכה היומית ובאדיבות מפעל המשניות",
                    "M2264.wav": "שימו לב חלוקת המשניות הינה אוטומטית והינכם מתחייבים לאמרו",
                    "M2265.wav": "בחלוקת מסכתות משניות זו, הושלמו עד כה",
                    "M2266.wav": "סדרי חלוקת מסכתות משניות",
                    "M2267.wav": "המסכת אותה קיבלתם לומר היא",
                    "M2268.wav": "לקבלת מסכת נוספת הקישו 1, לחזרה לתפריט הקישו 2",
                    "M2269.wav": "בחלוקת פרקי משניות זו, הושלמו עד כה",
                    "M2270.wav": "סדרי חלוקת פרקי משניות",
                    "M2271.wav": "פרק המשניות אותו קיבלתם ללמוד",
                    "M2272.wav": "פרק..",
                    "M2273.wav": "לקבלת פרק משניות נוסף הקישו 1, לחזרה לתפריט הקישו 2",
                    "M2284.wav": "נא הקישו את האות הבאה ולאחריה סולמית. לסיום ההקשות או לביטול הקשה אחרונה או לביטול כלל ההקשות הקישו כוכבית\"",
                    "M2285.wav": "נא הקישו את האות ולאחריה סולמית. לביטול ויציאה הקישו כוכבית",
                    "M2286.wav": "פריט סיום או ביטול לשינוי שפת מקלדת הקישו 6 לסיום ההקלדה הקישו 1 לשמיעת הטקסט שהוקלד הקישו 2 לביטול של האות האחרונה הקישו 3 לביטול והקלדה מחודשת של כל הטקסט הקישו 4 ליציאה הקישו 5\"",
                    "M2283.wav": "הגדרת שפת מקלדת - לעברית הקישו 1, לאנגלית הקישו 2",
                    "M4170.wav": "מצב הקלדה עברית - עודכן",
                    "M4171.wav": "מצב הקלדה אנגלית - עודכן",
                    "M2287.wav": "ביטול התקבל בהצלחה",
                    "M2288.wav": "הטקסט המעודכן הוא",
                    "M2289.wav": "טקסט שהוקלד הוא",
                    "M2290.wav": "אישור הקישו 1 לשמיעה חוזרת 2 להקשה מחודשת של כל הטקסט הקישו",
                    "M2291.wav": "שמוע את הטקסט שהוקלד באמצעות מנוע השמעת מילים הקישו 1 או המתינו, לשמוע את הטקסט שהוקלד אות אחר אות הקישו 2",
                    "M2292.wav": "רווח הקישו 0 וסולמית, לסיפרה עצמה הקישו 5 פעמים על הספרה וסולמית, לנקודה הקישו 1 וסולמית, לסימן שאלה הקישו 11 וסולמית, לסימן קריאה הקישו 111 וסולמית, לאות א הקישו 3 וסולמית, לאות ב הקישו 33 וסולמית, לאות ג הקישו 333 וסולמית, לאות ד הקישו 2 וסולמית, לאות ה הקישו 22 וסולמית, לאות ו הקישו 222 סולמית,, לאות ז הקישו 6 וסולמית, לאות ח הקישו 66 וסולמית, לאות ט הקישו 666 וסולמית, לאות י הקישו 5 וסולמית, לאות כ הקישו 55 וסולמית, לאות ך הקישו 555 וסולמית, לאות ל הקישו 5555 וסולמית, לאות מ הקישו 4 וסולמית, לאות ם הקישו 44 וסולמית, לאות נ הקישו 444 וסולמית, לאות ן הקישו 4444 וסולמית, לאות ס הקישו 9 וסולמית, לאות ע הקישו 99 וסולמית, לאות פ הקישו 999 וסולמית, לאות ף הקישו 9999 וסולמית, לאות צ הקישו 8 וסולמית, לאות ץ הקישו 88 וסולמית, לאות ק הקישו 888 וסולמית, לאות ר הקישו 7 וסולמית, לאות ש הקישו 77 וסולמית, לאות ת הקישו 777 וסולמית",
                    "M2470.wav": "שרות זה אינו פעיל במערכת זו אנא פנו לשרות הלקוחות",
                    "M2471.wav": "דירוג שביעות רצון מהשירות והעמידה בזמנים",
                    "M2472.wav": "דירוג שביעות רצון מהמקצועיות",
                    "M2473.wav": "דירוג שביעות רצון מהמחיר",
                    "M2474.wav": "לא הוגדר סוג זיהוי לחיפוש",
                    "M2475.wav": "אין קובץ מורשי עריכה",
                    "M2476.wav": "לא מוגדרים הרשאות עריכה עבורך",
                    "M2477.wav": "אנא הקישו את מספר הזיהוי של הלקוח וסולמית לסיום",
                    "M2478.wav": "סך הניקוד הקיים הלקוח הוא",
                    "M2479.wav": "להוספת ניקוד הקישו 1 להורדת ניקוד הקישו 2 להקשת מספר זיהוי של לקוח אחר הקישו כוכבית",
                    "M2480.wav": "הוספת ניקוד אנא הקישו את סכום הנקודות שברצונכם להוסיף",
                    "M2481.wav": "הורדת ניקוד אנא הקישו את סכום הנקודות שברצונכם להוריד",
                    "M2482.wav": "עדכון הנקודות התבצע בהצלחה סך הניקוד החדש הוא",
                    "M2483.wav": "לביצוע פעולות נוספות הקישו 1 לחזרה לתפריט קודם הקישו 2 או המתינו",
                    "M2484.wav": "לא ניתן להכנס למינוס נקודות",
                    "M2485.wav": "אין קובץ תורמים",
                    "M2486.wav": "משוייכים אליך",
                    "M2487.wav": "תורמים",
                    "M2488.wav": "אנא הקש את מספר הזיהוי של התורם לשמיעת כל התורמים ברצף הקישו אפס וסולמית. ליציאה הקישו כוכבית וסולמית",
                    "M2489.wav": "אין תורמים משויכיים אליך, אנא פנה למנהל הארגון",
                    "M2490.wav": "להלן הפירוט",
                    "M2491.wav": "סוף רשימה",
                    "M2492.wav": "תורם זה אינו קיים ברשימה שלך",
                    "M2493.wav": "תורם זה עדיין לא תרם",
                    "M2494.wav": "תורם זה תרם סך של",
                    "M2495.wav": "שקלים",
                    "M2496.wav": "לעדכון תרומה או סכום התרומה הקישו 1 לבדיקת מספר אחר הקישו 2",
                    "M2497.wav": "עדכון תרומה חדש, אנא עדכן את סכום התרומה המעודכן וסולמית לסיום",
                    "M2498.wav": "העדכון התבצע בהצלחה",
                    "M2499.wav": "בכל שלב ניתן להקיש 9 ולערוך את פרטי התרומה, או להקיש על כל מקש אחר לפרטי התורם הבא",
                    "M2508.wav": "בעיסקה זו תחויבו בסך..",
                    "M2509.wav": "לצורך השלמת הרכישה, יש להקיש את מספרי תעודות הזהות של המשתתפים עבורם נרכשו הכרטיסים. נרכשו",
                    "M2510.wav": "כרטיסים",
                    "M2511.wav": "אנא הקש את תעודת הזהות לכרטיס מספר",
                    "M2512.wav": "תעודת זהות אינה תקינה",
                    "M2513.wav": "בונוס!",
                    "M2514.wav": "קיבלתם",
                    "M2515.wav": "פריטים תוספת מתנה",
                    "M2516.wav": "סהכ כולל בונוס",
                    "M2517.wav": "אנא הקישו את יום החיוב וסולמית לסיום",
                    "M2518.wav": "אנא הקישו את סכום החיוב בכל חודש וסולמית לסיום",
                    "M2519.wav": "בעיסקה זו תחוייבו בכל חודש בסך",
                    "M2520.wav": "כמות החודשים לחיוב היא",
                    "M2521.wav": "אנא הקש מספר חודשים לחיוב וסולמית, לחיוב קבוע אנא הקישו אפס וסולמית",
                    "M2522.wav": "חיוב קבוע",
                    "M2523.wav": "תאריך החיוב הקרוב הוא",
                    "M2573.wav": "הפעולה בוצעה בהצלחה",
                    "M2700.wav": "כמות הנרשמים עד עכשיו היא",
                    "M2710.wav": "להקשה מחדש הקישו 1 או המתינו ליציאה הקישו 2",
                    "M2991.wav": "אנא הקישו את מספר ההקלטה כפי שברצונכם שתשמר, ובסיום הקישו סולמית",
                    "M2990.wav": "שם הקובץ שהוקש, כבר קיים בשלוחה, אנא הקישו שם קובץ אחר. אם ברצונכם שהקובץ הקיים יוחלף בקובץ החדש, הקישו שוב את מספר הקובץ הקיים",
                    "M3330.wav": "מספר הטלפון לא מזוהה במערכת, נא התקשרו ממספר מזוהה",
                    "M3331.wav": "לא הוגדרה רשימת צינטוקים",
                    "M3332.wav": "להצטרפות לרשימת הצינתוקים הקישו 1 להסרה מרשימת הצינתוקים הקישו 2 להשתקת צינתוקים עד לזמן מסוים הקישו 3, ליציאה הקישו כוכבית וסולמית",
                    "M3333.wav": "מספרכם כבר מופיע ברשימת הצינתוקים",
                    "M3334.wav": "מספר הטלפון שלכם נוסף בהצלחה לרשימת הצינתוקים",
                    "M3335.wav": "מספרכם לא מופיע ברשימת הצינתוקים",
                    "M3336.wav": "מספר הטלפון שלכם נמחק בהצלחה מרשימת הצינתוקים",
                    "M3337.wav": "להפעלת צינתוק הקישו 1 למחיקת מספר מרשימת הצינתוקים הקישו 2 לאיפוס כל רשימת הצינתוקים הקישו 3 ליציאה הקישו כוכבית וסולמית",
                    "M3338.wav": "הצינתוק הופעל בהצלחה",
                    "M3339.wav": "נא הקישו את המספר למחיקה ובסיום הקישו סולמית",
                    "M3340.wav": "המספר נמחק בהצלחה מרשימת הצינתוקים",
                    "M3341.wav": "המספר שהקשתם לא מופיע ברשימת הצינתוקים",
                    "M3342.wav": "שימו לב לאחר האיפוס לא ניתן יהיה לשחזר את המספרים האם הינכם בטוחים? לאישור האיפוס הקישו 1 לביטול ויציאה הקישו 2",
                    "M3343.wav": "איפוס רשימת הצינתוקים הסתיים בהצלחה",
                    "M3345.wav": "לשמיעת ההודעה הקישו אחת לאישור הקישו שתיים או סולמית להקלטה מחדש הקישו שלוש להמשך הקלטה הקישו ארבע",
                    "M3410.wav": "מספרכם אינו רשאי להירשם, לבירורים פנו לאחראי",
                    "M3411.wav": "הרישום בוצע בהצלחה. שלום ותודה",
                    "M3513.wav": "אנא הקישו את המספר הרצוי ובסיום סולמית",
                    "M3514.wav": "המספר שהוקש אינו קיים במערכת",
                    "M3515.wav": "להגרלת מספר אקראי הקישו 1, להקשה מחדש הקישו 2, ליציאה הקישו 3",
                    "M3516.wav": "הקוד שהוגרל הוא",
                    "M3520.wav": "לא הוגדר מספר חנות",
                    "M3521.wav": "מספר החנות שהוגדר לא קיים",
                    "M3522.wav": "סיסמת המוכר לחנות שהוגדרה בשלוחה אינה תקינה",
                    "M3523.wav": "נא הקישו את סיסמת הכניסה לחנות ולסיום הקישו סולמית",
                    "M3524.wav": "סיסמת החנות שהקשתם אינה תקינה",
                    "M3525.wav": "החנות סגורה כעת, שלום ותודה",
                    "M3526.wav": "נראה שעדיין לא נרשמתם למערכת המכירות, כדי לרכוש באחד מכל החניות של המערכת יש להירשם בהרשמה חד פעמית, תוכלו להירשם כאן בטלפון והטלפון שממנו התקשרתם ייכנס למערכת בתור הטלפון של החשבון, להרשמה כעת הקישו 1, ליציאה הקישו 2",
                    "M3527.wav": "ההרשמה נכשלה, יכול להיות שמספר הטלפון כבר רשום כשם משתמש, או שמספר הטלפון כבר נמצא במערכת על שם משתמש אחר, נא בדקו את הפרטים ונסו שוב",
                    "M3528.wav": "שגיאה כללית",
                    "M3529.wav": "נא הקישו את סיסמתכם האישית ולסיום הקישו סולמית",
                    "M3530.wav": "ניכר שזוהי הפעם הראשונה שהינכם נכנסים לחנות זו, מייד תעברו תהליך רישום קצר, ולאחמ\"כ כבר תהיו לקוחות רשומים של החנות",
                    "M3531.wav": "האם הינכם מעוניינים לקבל בדוא\"ל עדכונים ומבצעים וכדו' מהחנות, להצטרפות הקישו 1, להמשך ללא הצטרפות הקישו 2.",
                    "M3532.wav": "האם הינכם מעוניינים לקבל הודעות קוליות מעדכונים ומבצעים וכדו' מהחנות, להצטרפות הקישו 1, להמשך ללא הצטרפות הקישו 2.",
                    "M3533.wav": "האם הינכם מעוניינים לקבל הודעות סמס מעדכונים ומבצעים וכדו' מהחנות, להצטרפות הקישו 1, להמשך ללא הצטרפות הקישו 2.",
                    "M3534.wav": "הרשמתכם לחנות הסתיימה בהצלחה, מייד תעברו לחנות",
                    "M3535.wav": "ההרשמה לחנות נכשלה שלום ותודה",
                    "M3536.wav": "אינכם מורשים להיכנס לחנות זו, נא פנו למנהל החנות",
                    "M3537.wav": "ברוכים הבאים לחנות",
                    "M3538.wav": "בעגלת הקניות שלכם ישנם כרגע",
                    "M3539.wav": "מוצרים",
                    "M3540.wav": "שהם",
                    "M3541.wav": "פריטים",
                    "M3542.wav": "לעריכת המוצרים בעגלת הקניות הקישו 1, לרכישת מוצרים הקישו 2, למעבר לתשלום הקישו 3.",
                    "M3543.wav": "לשמיעת כל המוצרים שיש כעת בעגלת הקניות ברצף הקישו 1, לבחירת מוצר מעגלת הקניות ע\"פ המק\"ט הקישו 2, למחיקת ואיפוס כל עגלת הקניות הקישו 3 לחזרה הקישו 4",
                    "M3544.wav": "כעת יושמעו כל המוצרים בעגלת הקניות ברצף, בסיום שמיעת פרטי מוצר תועברו למוצר הבא, תוכלו להקיש בכל מוצר 1 לעריכת המוצר, 2 למוצר הבא, 3 למוצר הקודם, 4 ליציאה מהקראת עגלת הקניות, 5 למעבר לרכישת מוצרים נוספים, 6 למעבר לתשלום",
                    "M3545.wav": "שם המוצר",
                    "M3546.wav": "מחיר ליחידה",
                    "M3547.wav": "שקלים",
                    "M3548.wav": "הכמות שהוזמנה ממוצר זה",
                    "M3549.wav": "סך התשלום למוצר זה",
                    "M3550.wav": "לעריכת המוצר הקישו 1, למוצר הבא הקישו 2 או המתינו, למוצר הקודם הקישו 3, ליציאה מהקראת עגלת הקניות הקישו 4, למעבר לרכישת מוצרים נוספים הקישו 5, למעבר לתשלום הקישו 6.",
                    "M3551.wav": "לשינוי הכמות שהוזמנה ממוצר זה הקישו 1, למחיקת המוצר מעגלת הקניות הקישו 2, לחזרה לרשימת המוצרים בעגלת הקניות הקישו 3, ליציאה מהקראת המוצרים בעגלת הקניות הקישו 4",
                    "M3552.wav": "הכמות המעודכנת הוא",
                    "M3553.wav": "נא הקישו את הכמות החדשה שהינכם רוצים להזמין ממוצר זה ולסיום הקישו סולמית, לביטול הקישו אפס וסולמית",
                    "M3554.wav": "השינוי נקלט בהצלחה",
                    "M3555.wav": "השינוי נכשל",
                    "M3556.wav": "הינכם מבקשים למחוק את המוצר",
                    "M3557.wav": "לאישור הקישו 1, לביטול הקישו 2",
                    "M3558.wav": "המוצר נמחק בהצלחה מעגלת הקניות",
                    "M3559.wav": "מחיקת המוצר נכשלה",
                    "M3560.wav": "נא הקישו את מספר הקטלוגי של המוצר לסיום הקישו סולמית",
                    "M3561.wav": "מספר הקטלוגי של המוצר שגוי או שאינו מופיע בעגלת הקניות שלכם",
                    "M3562.wav": "לשינוי הכמות שהוזמנה ממוצר זה הקישו 1, למחיקת המוצר מהסל הקישו 2, להקשת מספר מק\"ט אחר הקישו 3, לחזרה הקישו 4",
                    "M3563.wav": "בחנות מוצעים כרגע",
                    "M3564.wav": "מחולקים ב",
                    "M3565.wav": "קטגוריות",
                    "M3566.wav": "לבחירת מוצר ע\"פ מק\"ט הקישו 1, לבחירת קטגוריית מוצרים הקישו 2, לשמיעת כל המוצרים ברצף הקישו 3, לשמיעת כל מוצרים ברצף מסודרים לפי הקטגוריות הקישו 4, למעבר לתשלום הקישו 5, לחזרה הקישו 6.",
                    "M3567.wav": "מספר המק\"ט שהוקש שגוי",
                    "M3568.wav": "המוצר שבחרתם אינו זמין לרכישה נא פנו למנהל החנות",
                    "M3569.wav": "משקל המוצר בגרמים",
                    "M3570.wav": "הכמות במלאי",
                    "M3571.wav": "להזמנה ממוצר זה הקישו את הכמות הרצויה ולסיום הקישו סולמית, להקשת מספר מק\"ט אחר הקישו 0 וסולמית, לחזרה הקישו סולמית",
                    "M3572.wav": "בחרת",
                    "M3573.wav": "סך התשלום למוצר זה כפול הכמות שבחרת הוא",
                    "M3574.wav": "שגיאה בהזמנת המוצר, הינכם מוחזרים",
                    "M3575.wav": "לא ניתן להזמין את הכמות הרצויה, נא בחרו כמות בשנית",
                    "M3576.wav": "המוצר נוסף בהצלחה לעגלת הקניות",
                    "M3577.wav": "להקשת מק\"ט נוסף הקישו 1, למעבר לתשלום הקישו 2, לחזרה הקישו 3",
                    "M3578.wav": "היכנם מועברים לסיכום הקניה ושמירתה",
                    "M3579.wav": "עגלת הקניות שלכם ריקה ולא ניתן לעבור לתשלום בעגלה ריקה, הינכם מועברים לרכישת מוצרים",
                    "M3580.wav": "סך התשלום לקנייה זו הינה",
                    "M3581.wav": "לאישור ומעבר לתשלום הקישו 1, לחזרה לשמיעת סיכום הקנייה הקישו 2, לחזרה למוצרים הקישו 3",
                    "M3582.wav": "לתשלום באשראי הקישו 1, לתשלום בקבלת נתונים הקישו 2, לתשלום במזומן הקישו 3, לתשלום בנקודות הקישו 4, לחזרה הקישו 5",
                    "M3583.wav": "הינכם מועברים לתשלום באשראי",
                    "M3584.wav": "הינכם מועברים לתשלום בקבלת נתונים",
                    "M3585.wav": "הינכם מועברים לתשלום במזומן",
                    "M3586.wav": "התשלום התקבל בהצלחה, נא המתינו לשמירת הקנייה שלכם",
                    "M3587.wav": "הקנייה נשמרה בהצלחה",
                    "M3588.wav": "הקנייה נשמרה ושולמה בהצלחה",
                    "M3589.wav": "שגיאה בשמירת הקנייה, נא פנו למנהל החנות",
                    "M3590.wav": "שגיאה בקבלת התשלום, הינכם מוחזרים לאפשריות תשלום",
                    "M3591.wav": "המוצר שבחרתם כבר נמצא בעגלת הקניות שלכם, הזמנה חדשה ממוצר זה, רק יוסיף על הכמות",
                    "M3592.wav": "להמשך לבחירת תוספת כמות ממוצר זה הקישו 1, לבחירת מק\"ט אחר הקישו 2",
                    "M3593.wav": "אנא המתינו, המערכת בודקת את תקינות עגלת הקניות שלכם.",
                    "M3594.wav": "המערכת מצאה כי יש אי תקינות בעגלת הקניות שלכם, יכול להיות שיש לכם מוצרים שנגמרו מהמלאי וכדו', תוכלו להמשיך לתשלום, המערכת יעדכן את המוצרים ואת הכמויות בעגלת הקניות לפי הכמות התקינה בלבד, והתשלום יהיה על המוצרים שיוזמנו בפועל בלבד, להמשך לתשלום ותיקון אוטומטי של עגלת הקניות הקישו 1, לשמיעת המוצרים שאינם תקינים, ותיקון שלהם הקישו 2",
                    "M3595.wav": "לאישור הזמנת הכמות הקישו 1, לתיקון הכמות הקישו 2, לבחירת מק\"ט אחר הקישו 3",
                    "M3596.wav": "מספר המק\"ט שהקשתם לא קיים בעגלת הקניות שלכם",
                    "M3597.wav": "הינכם עוברים כעת לתהליך הרשמה למרכז הקניות של חברת ימות המשיח פתרונות תקשורת, בהרשמתכם היכנם מסכימים להסכם ולתנאים, לאישור והמשך ההרשמה הקישו 1, לשמיעת ההסכם הקישו 2, ליציאה הקישו 3.",
                    "M3598.wav": "וכעת נבחר סיסמה, הסיסמה ישמש אותכם בכל פעם שתיכנסו לרכישת מוצרים גם באתר, וגם בטלפון, יש לבחור סיסמה של לפחות 6 מספרים, נא הקישו את הסיסמה, ולסיום הקישו סולמית",
                    "M3599.wav": "ההרשמה הסתיימה בהצלחה, ומעתה תוכל לרכוש במגוון החנויות של מרכז הקניות",
                    "M3600.wav": "הקלטה עצמית שם החנות",
                    "M3601.wav": "סוג השגיאה במוצר",
                    "M3602.wav": "מוצר לא תקין",
                    "M3603.wav": "הזמנה של כמות גדולה מהמלאי או מהמותר",
                    "M3604.wav": "פירוט השגיאה",
                    "M3605.wav": "המוצר לא זמין לרכישה",
                    "M3606.wav": "הכמות המותרת להזמנה ממוצר זה הוא",
                    "M3607.wav": "אם תשאירו את המוצר כך, המערכת יתקן אוטומטי בעת התשלום, לדילוג על תיקון המוצר ומעבר למוצר הבא הקישו 1, למחיקת המוצר מעגלת הקניות הקישו 2, לשינוי הכמות ממוצר זה הקישו 3, ליציאה מהקראת השגיאות הקישו 4",
                    "M3608.wav": "שגיאה בקבלת פרטי השגיאה של המוצר הינכם מועברים למוצר הבא",
                    "M3609.wav": "להזמנה ממוצר זה הקישו 1, למעבר למוצר הבא הקישו 2 או המתינו, למוצר הקודם הקישו 3, למעבר לתשלום הקישו 4, ליציאה מהקראת המוצרים הקישו 5",
                    "M3610.wav": "קוד המוצר - מק\"ט",
                    "M3611.wav": "נא הקישו את הכמות שברצונכם לרכוש ולסיום הקישו סולמית, למעבר למוצר הבא הקישו 0 וסולמית, לחזרה הקישו סולמית",
                    "M3612.wav": "לאישור הזמנת המוצר הקישו 1, לבחירת הכמות מחדש הקישו 2, למעבר למוצר הבא ללא הזמנה מהמוצר הזה הקישו 3",
                    "M3613.wav": "המוצר כבר נמצא בעגלת הקניות שלכם, הזמנה נוספת ממוצר זה רק יוסיף על הכמות הקיימת, להמשך הקישו 1, למעבר למוצר הבא הקישו 2",
                    "M3614.wav": "אין יותר קטגוריות להשמעה",
                    "M3615.wav": "מספר קטגורייה",
                    "M3616.wav": "שם הקטגורייה",
                    "M3617.wav": "לכניסה לקטגורייה זו הקישו 1, למעבר לקטגורייה הבאה הקישו 2 או המתינו, לחזרה לקטגורייה הקודמת הקישו 3, לחזרה הקישו 4",
                    "M3618.wav": "בקטגורייה זו ישנם כרגע",
                    "M3619.wav": "תתי קטגורייה",
                    "M3620.wav": "לשמיעת כל המוצרים מקטגורייה זו ברצף הקישו 1 או המתינו, לשמיעת המוצרים לפי תתי קטגוריות הקישו 2, למעבר לקטגורייה הבאה הקישו 3, לקטגורייה הקודמת הקישו 4, ליציאה מהקטגוריות הקישו 5",
                    "M3621.wav": "אין יותר תתי קטגוריות להשמעה",
                    "M3622.wav": "מספר תת הקטגורייה",
                    "M3623.wav": "שם תת הקטגורייה",
                    "M3624.wav": "לכניסה לתת קטגורייה זו הקישו 1, למעבר לתת קטגורייה הבאה הקישו 2 או המתינו, לחזרה לתת קטגורייה הקודמת הקישו 3, לחזרה הקישו 4",
                    "M3625.wav": "בתת קטגורייה זו ישנם כרגע",
                    "M3626.wav": "אין יותר מוצרים להשמעה בתת קטגורייה זו",
                    "M3627.wav": "אין יותר מוצרים להשמעה בחנות, הינכם מוחזרים",
                    "M3628.wav": "בחנות זו צריך לרכוש במינימום של",
                    "M3629.wav": "בחנות זו יש תוספת תשלום לכל רכישה בסך",
                    "M3630.wav": "בחנות זו אין שירות משלוחים",
                    "M3631.wav": "בחנות זו מוצע שירות משלוחים",
                    "M3632.wav": "בחנות זו מסופקים המוצרים במשלוח בלבד",
                    "M3633.wav": "מחיר המשלוח נקבע לפי משקל המוצרים שהוזמנו",
                    "M3634.wav": "המשלוח ניתן ללא עלות",
                    "M3635.wav": "מחיר המשלוח הוא",
                    "M3636.wav": "מחיר משלוח לכל קילו הוא",
                    "M3637.wav": "אין יותר מוצרים להשמעה בקטגורייה זו",
                    "M3638.wav": "אין יותר מוצרים בעגלת הקניות שלכם",
                    "M3639.wav": "אין יותר מוצרים עם שגיאה בעגלת הקניות, הינכם מועברים לבדיקת עגלת הקניות שלכם",
                    "M3640.wav": "להוספת משלוח הקישו 1, להמשך ללא משלוח הקישו 2",
                    "M3641.wav": "לרכישה שלכם נוספה משלוח בסך",
                    "M3642.wav": "נוסף משלוח לכתובת המעודכנת בחשבון שלכם",
                    "M3643.wav": "עלות תוספת התשלום לכל קנייה הינה בסך",
                    "M3644.wav": "עלות המשלוח",
                    "M3645.wav": "סך הכל לתשלום",
                    "M3646.wav": "עגלת הקניות שלכם נמצא תקין",
                    "M3647.wav": "לסיום קטגורייה זו הקישו 1 או המתינו, לשמיעה חוזרת של קטגורייה זו הקישו 2, למעבר לתשלום הקישו 3, לחזרה הקישו 4",
                    "M3648.wav": "הינכם מועברים לעריכת עגלת הקניות שלכם",
                    "M3649.wav": "לסיום תת קטגורייה זו הקישו 1 או המתינו, לשמיעה חוזרת של המוצרים מתת קטגורייה זו הקישו 2, לסיום בקטגורייה זו הקישו 3 למעבר לתשלום הקישו 4, לחזרה הקישו 5",
                    "M3650.wav": "שימו לב לאחר מחיקת עגלת הקניות, לא ניתן יהיה לשחזר אותה, לאישור המחיקה הקישו 1, לביטול הקישו 2",
                    "M3651.wav": "עגלת הקניות נמחקה בהצלחה",
                    "M3652.wav": "מחיקת עגלת הקניות נכשלה",
                    "M3653.wav": "הסניף המוגדר בשלוחה אינו תקין, נא פנו למנהל החנות",
                    "M3654.wav": "בחנות ישנם",
                    "M3655.wav": "סניפים",
                    "M3656.wav": "לסניף",
                    "M3657.wav": "הקישו",
                    "M3658.wav": "לא ניתן לשנות לכמות שהזנתם, נא בחרו כמות אחרת",
                    "M3659.wav": "סכום הקניה נמוך מהמינימום בחנות",
                    "M3660.wav": "הינך חורג ממספר הקניות המאושר לכל לקוח",
                    "M3661.wav": "סכום הקניה, חורג מהמקסימום שניתן לרכוש בקנייה",
                    "M3662.wav": "עברת את סכום המקסימום המותר לכל לקוח",
                    "M3663.wav": "מספר המוצרים בעגלת הקניות גבוה ממקסימום המוצרים הניתן לרכוש בכל קנייה",
                    "M3664.wav": "עברת את מקסימום המוצרים שכל לקוח יכול לרכוש מכלל הרכישות",
                    "M3665.wav": "מספר הפריטים בעגלת הקניות גבוה ממקסימום הפריטים הניתן לרכוש בכל קנייה",
                    "M3666.wav": "עברת את מקסימום הפריטים שכל לקוח יכול לרכוש מכל הרכישות",
                    "M3667.wav": "מספר המוצרים בעגלת הקניות נמוך מהמינימום שיש לרכוש",
                    "M3668.wav": "מספר הפריטים בעגלת הקניות נמוך מהמינימום שיש לרכוש",
                    "M3669.wav": "מינימום הסכום שיש לרכוש בקניה הוא",
                    "M3670.wav": "ואילו סכום הרכישה שלך הוא",
                    "M3671.wav": "מספר הקניות המאושר לכל לקוח הוא",
                    "M3672.wav": "בקנייה זו הינך מגיע לקנייה מספר",
                    "M3673.wav": "מקסימום הסכום שניתן לרכוש בקנייה הוא",
                    "M3674.wav": "מקסימום הסכום שכל לקוח יכול לרכוש בכל רכישותיו בחנות זו הוא",
                    "M3675.wav": "ואילו סכום הקניות שלכם כולל קנייה זו הוא",
                    "M3676.wav": "מקסימום המוצרים שניתן לרכוש בקנייה הוא",
                    "M3677.wav": "ואילו מספר המוצרים בקנייה שלכם הוא",
                    "M3678.wav": "מקסימום המוצרים שכל לקוח יכול לרכוש בכל הרכישות בחנות זו הוא",
                    "M3679.wav": "ואילו מספר המוצרים שלכם כולל קנייה זו הוא",
                    "M3680.wav": "מקסימום הפריטים שניתן לרכוש בקנייה הוא",
                    "M3681.wav": "ואילו מספר הפריטים בקנייה שלכם הוא",
                    "M3682.wav": "מקסימום הפריטים שכל לקוח יכול לרכוש בכל הרכישות בחנות זו הוא",
                    "M3683.wav": "ואילו מספר הפריטים שלכם כולל קנייה זו הוא",
                    "M3684.wav": "מספר המוצרים המינימלי שיש לרכוש בחנות הוא",
                    "M3685.wav": "מספר הפריטים המינימלי שיש לרכוש בחנות הוא",
                    "M3686.wav": "לחזרה לעריכת הקניה הקישו 1, לאיפוס ומחיקת כל הסל הקישו 2, ליציאה הקישו 3",
                    "M3687.wav": "לאיפוס ומחיקת כל הסל הקישו 1, ליציאה הקישו 2",
                    "M3688.wav": "סך הנחה לקנייה זו",
                    "M3689.wav": "המערכת מצאה כי יש קניות שעדיין לא שולמו, למעבר לפירוט ולתשלום הקישו 1, להמשך לחנות הקישו 2",
                    "M3690.wav": "המערכת מצאה כי יש קניות שעדיין לא שולמו, הינכם מועברים לשמיעת פירוט הקניות ותשלום עליהם",
                    "M3691.wav": "מספר קנייה",
                    "M3692.wav": "לתשלום על הקנייה הקישו 1, למעבר לקניה הבאה הקישו 2 או המתינו, לקנייה הקודמת הקישו 3, ליציאה הקישו 4",
                    "M3693.wav": "לתשלום באשראי הקישו 1, לתשלום בקבלת נתונים הקישו 2",
                    "M3694.wav": "אין יותר קניות שעדיין לא שולמו",
                    "M3695.wav": "בחנות מוצעת הנחה של",
                    "M3696.wav": "אחוזים",
                    "M3697.wav": "ההנחה מותנית בקנייה של מעל",
                    "M3698.wav": "הכמות שהוזמנה ממוצר זה קטנה מהמינימום שניתן להזמין",
                    "M3699.wav": "הכמות המינימלית למוצר זה הוא",
                    "M3800.wav": "מספר המק\"ט שהוגדר בשלוחה שגוי",
                    "M3801.wav": "המק\"ט המוגדר בשלוחה, אינו זמין לרכישה, נא פנו למנהל החנות",
                    "M3802.wav": "להמשך לבחירת תוספת כמות ממוצר זה הקישו 1, ליציאה הקישו 2",
                    "M3803.wav": "לאישור הזמנת הכמות הקישו 1, לתיקון הכמות הקישו 2, לחזרה הקישו 3",
                    "M3804.wav": "שגיאה בהזמנת המוצר, הינכם מוחזרים",
                    "M3805.wav": "למעבר לתשלום הקישו 1, ליציאה הקישו 2",
                    "M3806.wav": "שגיאה בשמירת הקנייה, נא פנו למנהל המערכת, הינכם מועברים לקנייה הבאה",
                    "M3807.wav": "קודם נבחר שם משתמש, שם המשתמש ישמש אותכם לזיהוי במערכת, וכן בעת כניסתכם באתר האינטרנט, אם זה לא משנה לכם, תוכלו לדלג על זה ושם המשתמש יהיה מספר הטלפון ממנו אתם מחייגים (ותוכלו לשנות את שם המשתמש באתר האינטרנט במועד מאוחר יותר), להקלטת שם משתמש הקישו 1, להקשת שם משתמש במספרים, הקישו 2, לדילוג על הכנסת שם המשתמש הקישו 3",
                    "M3808.wav": "נא הקליטו את שם המשתמש ובסיום הקישו סולמית",
                    "M3809.wav": "הקלטת שם המשתמש הסתיים בהצלחה",
                    "M3810.wav": "נא הקישו את שם המשתמש במספרים ולסיום הקישו סולמית",
                    "M3811.wav": "בחרתם לדלג על הקלטת שם משתמש, ושם המשתמש יהיה מספר הטלפון ממנו אתם מחייגים",
                    "M3812.wav": "כעת תוכלו להוסיף מייל לחשבון שלכם, כך תוכלו לקבל פירוטי קניות ישירות למייל ומידע חשוב, למעבר כעת להקשת מייל הקישו 1, לדילוג על הכנסת המייל הקישו 2",
                    "M3813.wav": "הינכם מועברים להקשת מייל",
                    "M3814.wav": "כתובת המייל נקלטה בהצלחה",
                    "M3815.wav": "מודול קניות",
                    "M3816.wav": "להקלטת שם פרטי הקישו 1, לדילוג הקישו 2",
                    "M3817.wav": "נא הקליטו את שם הפרטי ולסיום הקישו סולמית",
                    "M3818.wav": "שם הפרטי שהוקלט נקלט בהצלחה",
                    "M3819.wav": "להקלטת שם משפחה הקישו 1, לדילוג הקישו 2",
                    "M3820.wav": "נא הקליטו את שם המשפחה ולסיום הקישו סולמית",
                    "M3821.wav": "שם המשפחה נקלט בהצלחה",
                    "M3822.wav": "כעת תוכלו להוסיף פרטי כתובת מגורים, למקרה של משלוח, וכדו', להכנסת פרטי כתובת הקישו 1, לדילוג הקישו 2",
                    "M3823.wav": "נא הקליטו את עיר המגורים ולסיום הקישו סולמית",
                    "M3824.wav": "נא הקליטו את שם הרחוב ולסיום הקישו סולמית",
                    "M3825.wav": "נא הקישו את מספר הבית ולסיום סולמית",
                    "M3826.wav": "באם למספר הבית יש כמה כניסות הקישו את הכניסה במספרים ולסיום סולמית, לדוגמה לכניסה א הקישו 1 וסולמית, באם אין כניסות הקישו סולמית",
                    "M3827.wav": "נא הקישו מספר דירה ולסיום סולמית, לדילוג הקישו סולמית",
                    "M3828.wav": "נא הקישו מיקוד ולסיום סולמית, לדילוג הקישו סולמית",
                    "M3829.wav": "מספר הטלפון אינו מזוהה, לא ניתן להמשיך במערכת המכירות בצורה טלפונית ללא מספר טלפון, נא התקשרו מטלפון מזוהה, או לחילופין היכנסו דרך אתר האינטרנט באמצעות שם משתמש וסיסמה",
                    "M3830.wav": "לקבלת משלוח לכתובת המעודכנת בחשבון שלכם הקישו 1, לקבלת המשלוח לכתובת אחרת הקישו 2, לשמיעת הכתובת המעודכנת בחשבון שלכם הקישו 3",
                    "M3831.wav": "להקלטת פרטי הכתובת האחרת הקישו 1, להקשת הפרטים במקשי הטלפון הקישו 2 לחזרה לבחירת הכתובת הקישו 3",
                    "M3832.wav": "נא הקישו את שם העיר",
                    "M3833.wav": "נא הקישו את שם הרחוב",
                    "M3834.wav": "באם איש הקשר לקבלת המשלוח הוא בעל החשבון תוכלו לדלג ע\"י הקשת 1, באם יש איש קשר אחר לקבלת המשלוח הקישו 2 להזנת פרטיו",
                    "M3835.wav": "נא הקישו את שם איש הקשר למשלוח",
                    "M3836.wav": "נא הקישו את מספר הטלפון של איש הקשר",
                    "M3837.wav": "נא הקליטו את שם איש הקשר למשלוח",
                    "M3838.wav": "אם הפרטים נכונים הקישו 1, להכנסת פרטי המשלוח מחדש הקישו 2, לשמיעה חוזרת של הפרטים הקישו 3",
                    "M3839.wav": "אם יש לך הערה מיוחדת למשלוח הקישו 1, לדילוג הקישו 2",
                    "M3840.wav": "נא הקישו את ההערה",
                    "M3841.wav": "נא הקליטו את ההערה ולסיום סולמית",
                    "M3842.wav": "שגיאה בהקלדת האותיות, הינכם מוחזרים",
                    "M3843.wav": "הפרטים שנקלטו",
                    "M3844.wav": "שם העיר",
                    "M3845.wav": "שם הרחוב",
                    "M3846.wav": "מספר בית",
                    "M3847.wav": "כניסה",
                    "M3848.wav": "מיקוד",
                    "M3849.wav": "מספר דירה",
                    "M3850.wav": "שם איש הקשר למשלוח",
                    "M3851.wav": "טלפון איש הקשר",
                    "M3852.wav": "הערה למשלוח",
                    "M3853.wav": "משלוח נוסף בהצלחה לכתובת שהכנסתם",
                    "M3854.wav": "המערכת זיהתה שמספר הטלפון איתו התקשרתם רשום בכמה חשבונות במרכז הקניות, הינכם מועברים לבחירת שם המשתמש איתו אתם רוצים להיכנס",
                    "M3855.wav": "למשתמש",
                    "M3856.wav": "אין פרטי כתובת בחשבונך, שלום ותודה",
                    "M3857.wav": "לכניסה לחנות הקישו 1, לשמיעת היסטוריית 10 קניות אחרונות שלך הקישו 2, לעריכת הפרטים בחשבונך הקישו 3, ליציאה הקישו 4",
                    "M3858.wav": "תשלום כולל בסך",
                    "M3859.wav": "לשמיעת פירוט הקנייה המלאה הקישו 1, למעבר לקנייה הבאה הקישו 2 או המתינו, לקנייה הקודמת הקישו 3, לחזרה הקישו 4",
                    "M3860.wav": "סוף רשימת הקניות",
                    "M3861.wav": "בקנייה זו רכשתם",
                    "M3862.wav": "סך התשלום על המוצרים היה",
                    "M3863.wav": "נוסף תוספת תשלום בסך",
                    "M3864.wav": "עלות המשלוח היה",
                    "M3865.wav": "קיבלתם הנחה בסך",
                    "M3866.wav": "פירוט הקנייה",
                    "M3867.wav": "סך הכל למוצר זה",
                    "M3868.wav": "סוף רשימת המוצרים",
                    "M3869.wav": "שם המשתמש שלך הוא",
                    "M3870.wav": "לשמיעת הפרטים המעודכנים היום בחשבון הקישו 1, לשינוי סיסמת החשבון והגדרות אבטחה הקישו 2, לשינוי פרטים הקישו 3, לשמיעת 10 קניות אחרונות הקישו 4, לחזרה הקישו 5",
                    "M3871.wav": "שם פרטי",
                    "M3872.wav": "שם משפחה או שם העסק",
                    "M3873.wav": "כתובת אימייל",
                    "M3874.wav": "מספר טלפון",
                    "M3875.wav": "מספר טלפון בבית",
                    "M3876.wav": "מספר טלפון נוסף",
                    "M3877.wav": "מוגדר לבקש סיסמה לפני ביצוע קנייה",
                    "M3878.wav": "מוגדר לא לבקש סיסמה לפני ביצוע קניה",
                    "M3879.wav": "לשינוי הסיסמה הקישו 1, לשינוי הגדרת בקשת סיסמה לפני ביצוע קניייה הקישו 2, לשינוי הגדרת אימות טלפוני לפני ביצוע קנייה הקישו 3, לחזרה הקישו 4",
                    "M3880.wav": "נא בחרו סיסמה חדשה, הסיסמה צריכה להיות לפחות 6 ספרות, ולסיום הקישו סולמית, לביטול הקישו כוכבית וסולמית",
                    "M3881.wav": "שינוי הפרטים נקלט בהצלחה",
                    "M3882.wav": "שגיאה בשינוי הפרטים הינכם מוחזרים",
                    "M3883.wav": "להגדרה שלא יבקש סיסמה לפני ביצוע קנייה הקישו 1, להגדרה שכן יבקש סיסמה הקישו 2 לחזרה הקישו 3",
                    "M3884.wav": "לשינוי שם הפרטי הקישו 1, לשינוי שם המשפחה או שם העסק הקישו 2, לשינוי מספר הטלפון הקישו 3, לשינוי מספר הטלפון בבית הקישו 4, לשינוי מספר הטלפון הנוסף הקישו 5 לשינוי דואר אלקטרוני - אימייל הקישו 6, לשינוי כתובת מגורים הקישו 7, לחזרה הקישו 8",
                    "M3885.wav": "האם תרצו שבכל קניה בטלפון תצטרכו להקיש את הסיסמה שבחרת, להגדרה שיבקש סיסמה הקישו 1, להגדרה שלא יבקש סיסמה הקישו 2",
                    "M3886.wav": "משלוח לכתובת המעודכנת",
                    "M3887.wav": "בעיסקה זו תחויבו בסך",
                    "M3888.wav": "נקודות",
                    "M3889.wav": "לאישור הקישו 1 לחזרה הקישו 2",
                    "M3890.wav": "לסיום הקנייה ומעבר לתשלום ושמירה הקישו 1 או המתינו, לשמיעה חוזרת של המוצרים הקישו 2, לחזרה לתחילת החנות הקישו 3, ליציאה הקישו 4",
                    "M3891.wav": "לתשלום ב",
                    "M3892.wav": "כרטיס אשראי",
                    "M3893.wav": "קבלת נתונים",
                    "M3894.wav": "מזומן",
                    "M3895.wav": "הקישו",
                    "M3896.wav": "שגיאה בהגדרות אמצעי התשלום",
                    "M3897.wav": "הינכם מועברים לתשלום בנקודות",
                    "M3898.wav": "האופצייה עדיין בבנייה נסו שוב מאוחר יותר",
                    "M3899.wav": "בכדי להיכנס לחנות נא הקישו את מספר החנות ובסיום סולמית",
                    "M3935.wav": "להוספה למספר דקות, הקישו 1, למספר שעות, הקישו 2, למספר ימים הקישו 3, למספר חודשים, הקישו 4.",
                    "M3936.wav": "הקישו את כמות מספר הדקות שברצונכם להיות מחוברים לקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3937.wav": "הקישו את כמות מספר השעות שברצונכם להיות מחוברים לקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3938.wav": "הקישו את כמות מספר הימים שברצונכם להיות מחוברים לקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3939.wav": "הקישו את כמות מספר החודשים שברצונכם להיות מחוברים לקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3940.wav": "להשתקה למספר דקות, הקישו 1, למספר שעות, הקישו 2, למספר ימים הקישו 3, למספר חודשים, הקישו 4.",
                    "M3941.wav": "הקישו את כמות מספר הדקות שברצונכם להיות מנותקים מקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3942.wav": "הקישו את כמות מספר השעות שברצונכם להיות מנותקים מקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3943.wav": "הקישו את כמות מספר הימים שברצונכם להיות מנותקים מקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3944.wav": "הקישו את כמות מספר החודשים שברצונכם להיות מנותקים מקבלת הצינתוקים, ולסיום, הקישו סולמית",
                    "M3945.wav": "מספר הטלפון שלכם נוסף בהצלחה לרשימת הצנתוקים למשך הזמן שהגדרתם",
                    "M3946.wav": "מספר הטלפון שלכם הוסר בהצלחה מרשימת הצנתוקים למשך הזמן שהגדרתם",
                    "M3949.wav": "אנא הקישו את הערך הרצוי ובסיום הקישו סולמית",
                    "M3985.wav": "מספר הטלפון אינו זמין, אנא נסו שוב במועד מאוחר יותר",
                    "M3987.wav": "השלוחה לא הוגדרה, יש להגדיר שליחת מייל או סמס",
                    "M3988.wav": "המספר עבורו מופעל השירות לא מוגדר",
                    "M3989.wav": "מספר הטלפון שהוכנס לשליחת הסמס לא תקין",
                    "M4108.wav": "מתוכם, כמות המספרים הפעילים היא",
                    "M4109.wav": "וכמות המספרים המושתקים היא",
                    "M4400.wav": "לכניסה לחנות הקישו 1, לשמיעת והגדרת פרטים אישיים והגדרות אבטחה הקישו 2",
                    "M4401.wav": "כדי להיכנס לאיזור האישי יש להקיש את סיסמת הניהול ולסיום סולמית אי הקשת הסיסמה הנכונה יגרום לשיבוש בהמשך האיור האישי, אם שכחתם את הסיסמה הקישו 0 וסולמית",
                    "M4402.wav": "שגיאה בקבלת הגדרות האבטחה של חשבונך הינך מוחזר",
                    "M4403.wav": "שגיאה בשינוי הסיסמה, הינך מוחזר",
                    "M4404.wav": "שינוי סיסמה בוצע בהצלחה",
                    "M4405.wav": "שגיאה בקליטת השינוי הינך מוחזר",
                    "M4406.wav": "השינוי נקלט בהצלחה",
                    "M4407.wav": "נא הקישו את מספר הטלפון ולסיום סולמית, לביטול הקישו 0 וסולמית",
                    "M4408.wav": "לשינוי עיר מגורים הקישו 1, לשינוי רחוב הקישו 2, לשינוי מספר בית הקישו 3, לשינוי כניסה הקישו 4, לשינוי המיקוד הקישו 5, לשינוי מספר הדירה הקישו 6, לחזרה הקישו 7",
                    "M4409.wav": "א הקישו את מספר הבית ולסיום סולמית לביטול הקישו 0 וסולמית",
                    "M4410.wav": "נא הקישו את מספר הכניסה ולסיום סולמית לביטול הקישו 0 וסולמית",
                    "M4411.wav": "נא הקישו את המיקוד ולסיום סולמית לביטול הקישו 0 וסולמית",
                    "M4412.wav": "נא הקישו את מספר הדירה ולסיום סולמית לביטול הקישו 0 וסולמית",
                    "M4413.wav": "כעת תקבלו שיחת צינתוק, עליכם לשמור את הארבע ספרות אחרונות של המספר, לאחמ\"כ תצטרכו להקיש אותם כדי לבצע אימות",
                    "M4414.wav": "המערכת לא הצליחה להוציא שיחת אימות לטלפון המעודכן למערכת, נא פנו למנהל המערכת",
                    "M4415.wav": "נא הקישו את ארבע ספרות אחרונות של המספר שהתקשר אליכם עכשיו ולסיום הקישו סולמית",
                    "M4416.wav": "כעת תוכלו להוסיף עוד טלפון לחשבון, להוספת טלפון בבית הקישו 1 לסיום ומעבר לביצוע הרשמה הקישו 2",
                    "M4417.wav": "להוספת טלפון נוסף הקישו 1, לסיום ומעבר לביצוע ההרשמה הקישו 2",
                    "M4418.wav": "מספר החנות",
                    "M4419.wav": "שם החנות",
                    "M4420.wav": "תאריך הקנייה",
                    "M4421.wav": "עלות הקניה",
                    "M4422.wav": "להכנסת שם איש הקשר בהקלטה הקישו 1, להכנסת שם איש הקשר בהקשה הקישו 2, לחזרה הקישו 3",
                    "M4423.wav": "להכנסת ההערה בהקלטה הקישו 1, להכנסת ההערה בהקשה הקישו 2 לחזרה הקישו 3",
                    "M4424.wav": "במוצר זה יש לבחור",
                    "M4425.wav": "בחירתך נקלטה, בנוסף במוצר זה יש לבחור",
                    "M4426.wav": "ל...",
                    "M4427.wav": "וסולמית",
                    "M4428.wav": "לקטגורייה",
                    "M4429.wav": "לשמיעת כל המוצרים מקטגורייה זו ברצף הקישו 1, לשמיעת כל המוצרים מסודרים לפי תתי קטגוריות הקישו 2, לחזרה להקשת קטגורייה אחרת הקישו 3, לחזרה לתחילת החנות הקישו 4",
                    "M4430.wav": "יש לנו פרטים שהכניס מוכר עליך, הקש 1 לשמיעת הפרטים, הקש 2 לאישור והרשמה עם הפרטים האלו, הקש 3 להרשמה רגילה והכנסה מחדש של כל הפרטים",
                    "M4431.wav": "בכדי להיכנס לחנות זו, יש ליצור קשר עם מנהל החנות ע\"מ שירשום אתכם כלקוחות, שלום ותודה",
                    "M4432.wav": "כעת יושמעו כל המוצרים בחנות בכל מוצר תוכלו להקיש 1 להזמנה מהמוצר, 2 או המתנה בכדי לעבור למוצר הבא, 3 למוצר קודם, 4 למעבר לתשלום, 5 ליציאה מהקראת המוצרים",
                    "M4433.wav": "כעת יושמעו כל הקטגוריות ברצף, בכל קטגורייה תוכלו להקיש 1 לכניסה לקטגורייה, 2 או המתנה בכדי לעבור לקטגורייה הבאה, 3 לחזרה לקטגורייה קודמת, 4 לחזרה",
                    "M4434.wav": "כעת יושמעו כל תתי הקטגוריות ברצף, בכל תת קטגורייה תוכלו להקיש 1 לכניסה לתת הקטגורייה, 2 או המתנה בכדי לעבור לתת קטגורייה הבאה, 3 לחזרה לתת קטגורייה קודמת, 4 לחזרה           "
                }
                for (let item of this.messages) {
                    item.message = messages[item.name] || "";
                    if (item.message.length > 115) {
                        let short = item.message.slice(0, 115).concat('...');
                        item.fullMessage = item.message;
                        item.message = short;
                    }
                }
            })();
        },
        loadStatistics() {
            (async () => {
                const body = { token: sessionStorage.token, what: `ivr2:/Log/LogCounters.ini` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTextFile`, body);
                let currentExt = this.$route.query.path.replace("ivr2:/", "").replace("ivr2:", "");
                let logs = response.data.contents ? response.data.contents.split("\r\n") : ''
                for (let folder of logs) {
                    if (folder.match(`Foldar-${currentExt}`)) {
                        this.totalEntersCount = folder.replace(`Foldar-${currentExt}=`, "");
                        break
                    }
                }
            })();
        },
        loadSettings() {
            (async () => {
                const body = { token: sessionStorage.token, what: `${this.$route.query.path}/ext.ini` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTextFile`, body);
                const settingsData = (await axios.get('http://ivr.teltech.info/settings.json')).data
                const settings = response.data.contents.split('\n').map(s => s.split('=')).map(([k, v]) => ({ [k]: v }));
                const extTypes = {
                    playfile: 'השמעת קבצים',
                    confbridge: 'חדר ועידה',
                    admin_login: 'כניסה לניהול',
                    record: 'הקלטות',
                    routing: 'ניתוב שיחות',
                    routing_time: 'ניתוב שיחה לפי זמנים',
                    routing_yemot: 'הפניה למערכת אחרת',
                    points_say_total: 'השמעת הניקוד',
                    last_play: 'חזרה להשמעה אחרונה',
                    voice_mail: 'תא קולי עד 100 הודעות',
                    template_add_number: 'הוספת מספר לרשי״ת',
                    template_remove_number: 'הסרת מספר מרשי״ת',
                    menu_star: 'תפריט כוכבית',
                    message_options_menu: 'הוראות הפעלה',
                    oref_alerts: 'צבע אדום',
                    oref_alerts_quiet_wave: 'הגל השקט',
                    zmanim: 'זמני היום',
                    exchange_rates: 'שערי מט״ח',
                    play_and_return: 'השמעת הודעה אחת',
                    voicemail_email: 'תא קולי למייל',
                    conference_amount: 'חדר ועידה מוגבל לכמות משתתפים',
                    toplay_time: 'השמעת הודעה לפי תאריך',
                    chapter_receive: 'חלוקת תהילים',
                    trivia_questions: 'טריוויה',
                    say_hour_and_minute: 'השעה כעת',
                    approval_number: 'חלוקת מספרים',
                    recording_and_entering_data: 'קבלת נתונים',
                    phone_play_list: 'השמעות אישיות',
                    routing_1800: 'הפניה למספר 1800',
                    menu_voice: 'תפריט עם זיהוי דיבור',
                    sending_sms: 'שליחת sms',
                    go_to_folder_time: 'הפניה לתיקיות לפי זמנים',
                    stt_dir_all_file: 'המרת קול לטקסט',
                    points_save: 'הוספת ניקוד',
                    hangup: 'ניתוק השיחה',
                    playdir_time: 'שידור חי מדומה',
                    private_did_customer: 'קבלת מספר אישי',
                    tzintuk: 'מודול צינתוקים',
                    go_to_folder_from_list_all_information: 'פילטר לפי רשימות',
                    nedarim_plus: 'סליקת אשראי - נדרים',
                    pelecard: 'סליקת אשראי - פלאקארד',
                    cardcom: 'סליקת אשראי - קארדקום',
                    chapter_receive_mishnayot_select: 'חלוקת משניות',
                    study_tracking: 'מעקב לימודים',
                    go_to_folder_count: 'הפניה לפי כמות אנשים',
                    go_to_folder: 'מעבר לשלוחה אחרת',
                    music_on_hold: 'מזיקה בהמתנה',
                    queue: 'מודול תור',
                    send_fax: 'שליחת פקס',
                    recv_fax: 'קבלת פקס',
                    examination: 'מודול מבחן',
                    seker: 'סקר',
                    fundraising: 'מעקב גיוס תרומות',
                    members_active: 'כמות חברים פעילים',
                    counter_calculator: 'חישוב מונה',
                    donation_campaign: 'התרמות - מאצ׳ינג',
                    points_edit: 'הוספת/הורדת נקודות',
                    yemot_dialer_campaign_list: 'ניהול רשי״ת',
                    tehillim_select_save_and_listen: 'הקצאת פרקי תהילים',
                    points_to_other_id: 'הוספת ניקוד למשתמש אחר',
                    examination_american: 'מבחן אמריקאי',
                    block_id_type: 'חסימת משתמש',
                    coupon: 'חלוקת קופונים',
                    credit_card: 'סליקת אשראי - כללי',
                    id_message: 'הודעות אישיות',
                    id_list_message: 'השמעת הודעות ברצף',
                    record_system_messages: 'הקלטת הודעות מערכת',
                    folder_play_random: 'הפעלת שלוחה רנדומלית',
                    playfile_time: 'תזמון הפעלת קובץ',
                    yemot_dialer_campaign_start: 'הפעלת קמפיין מהירה',
                    template_filter: 'פילטר משתמשים לפי רש״ית',
                    sale_products: 'הזמנת מצרים',
                    daily_message: 'הודעה יומית ומעבר לשלוחה אחרת',
                    go_to_folder_date: 'העברה לשלוחה לפי זמנים',
                    tasks_report: 'דיווח משימות',
                    checking_units: 'בדיקת יתרת יחידות',
                    time_keeper: 'שעון נוכחות',
                    routing_ip: 'ניתוב השיחה לIP',
                    points_and_rating: 'נקודות ללקוח על קניה',
                    limit_call_seconds: 'הגבלת זמן שיחה',
                    calculator_add_percentage: 'מחשבון אחוזי תוספת',
                    access_filter: 'פילטר כניסה',
                    number_now_is: 'המספר כעת',
                    say_amount_subscribers: 'השמעת כמות נרשמים בקבלת נתונים',
                    amount_incoming_phone_numbers: 'ספירת כמות כניסות לשלוחה',
                    nitoviya: 'ניתוביה',
                    nitoviya_b_say_number: 'שמיעת מספר ניתוביה',
                    donation_campaign_some_actions: 'מאצ׳ינג ואפשרויות נוספות',
                    private_did: 'הוצאת וקבלת שיחות',
                    menu: 'תפריט',
                }
                this.settings = {}
                for (let setting of settings) {
                    Object.assign(this.settings, setting);
                }
                for (let setting in this.settings) {
                    if (this.settings[setting] == 'yes') this.settings[setting] = this.$t('yes')
                    if (this.settings[setting] == 'no') this.settings[setting] = this.$t('no')
                }
                this.settingsData = { all: [], custom: [] }
                for (let set of settingsData) {
                    if (set.type == 'all') this.settingsData.all.push(set)
                    if (set.type == this.settings['type']) this.settingsData.custom.push(set)
                }
                this.settings['type'] = extTypes[this.settings['type']] || this.settings['type'];
            })();
        },
        setUploadType() {
            if (this.uploadType === "ini") {
                console.log("ini")
            } else {
                console.log("outher")
            }
        },
        inputRules() {
            const match = this.newIniFileName.match(/.ini/g)
            if (match) {
                this.newIniFileName.replace(/.ini/g, 'a')
            } else {
                console.log("no")
            }
        },
        checkType() {
            if (this.extType === "menu") {
                console.log(this.extType)
            }
        },
        playSound(sound) {
            if (sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        redirect(item) {
            (async () => {
                const what = item.what;
                const body = { token: sessionStorage.token, what: item.what };
                if (item.fileType === this.$t('extnetion') || item.fileType === this.$t('folder')) {
                    const checkPerms = await axios.get('/api/users/getPerms', { headers: { 'Authorization': `Bearer ${sessionStorage.uToken}` } });
                    if (checkPerms.config.headers.Authorization == 'Bearer undefined') {
                        this.$router.push({ path: 'ivr', query: { path: item.what } })
                        this.loadData();
                        this.loadMsg();
                        this.loadSettings();
                    }
                    else {
                        if (checkPerms.data.users[0].extnetions.includes(item.what) || checkPerms.data.users[0].admin == "1") {
                            this.$router.push({ path: 'ivr', query: { path: item.what } })
                            this.loadData();
                            this.loadMsg();
                            this.loadSettings();
                            for (let item of this.items) {
                                if (!checkPerms.data.users[0].extnetions.includes(item.what)) {
                                    const i = this.items.indexOf(item)
                                    delete this.items[i]
                                }
                            }
                        }
                        else {
                            this.alert = true;
                            this.alertType = "warning";
                            this.alertContent = this.$t('accessForbiddenToExt')
                        }
                    }
                }
                else if (item.fileType === this.$t('settingsFile') || item.fileType === "קובץ בינארי" | item.fileType === this.$t('readFile')) {
                    this.viewFile = true;
                    const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTextFile`, body);
                    this.fileTextContent = response.data.contents;
                    this.viewFilePath = item.what;
                    this.fileEdit = false;
                }
                else if (item.fileType === this.$t('logFile')) {
                    this.viewFile = true;
                    const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetTextFile`, body);
                    this.fileTextContent = response.data.contents;
                    this.viewFilePath = item.what;
                    this.fileEdit = true;
                }
                else if (item.fileType === "CSV") {
                    location.href = `https://${sessionStorage.server}.call2all.co.il/ym/api/DownloadFile?${sessionStorage.token}&path=${what}`;
                }
                else if (item.fileType === this.$t('audioFile')) {
                    this.audioPath = null;
                    this.audioPlayer = true;
                    this.nowPlaying = item.name
                    this.audioPath = `https://${sessionStorage.server}.call2all.co.il/ym/api/DownloadFile?token=${sessionStorage.token}&path=${item.what}`
                }
            })();
        },
        extFrom() {
            if (this.newExtFromType === "fromlist") {
                this.fromList = true;
                this.fromType = false;
            }
            else if (this.newExtFromType === "fromType") {
                this.fromList = false;
                this.fromType = true;
            }
        },
        deleteItem(item) {
            (async () => {
                const body = { token: sessionStorage.token, action: "delete", what: item.what };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('fileDeleteSuccess')
                    this.loadData();
                    this.loadMsg();
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('fileDeleteError')
                }
            })();
        },
        createFolder() {
            (async () => {
                const body = { token: sessionStorage.token, path: `${this.$route.query.path}/${this.newFolderName}`, type: this.newFolderType };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/UpdateExtension`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('extCreatedSuccess')
                    this.loadData()
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('extCreatedError')
                }
            })();
            this.newExt = false;
        },
        saveChanges() {
            (async () => {
                const body = { token: sessionStorage.token, what: this.viewFilePath, contents: this.fileTextContent };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/UploadTextFile`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('savedSuccess')
                    this.loadData()
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('error')
                }
            })();
        },
        uploadINI() {
            (async () => {
                const body = { token: sessionStorage.token, what: `${this.$route.query.path}/${this.newIniFileName}.ini`, contents: this.newIniFileContent };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/UploadTextFile`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('uploadFileSuccess')
                    this.loadData()
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('uploadFileError')
                }
            })();
            this.uploadFiles = false;
        },
        uploadTTS() {
            (async () => {
                const body = { token: sessionStorage.token, what: `${this.$route.query.path}/${this.newTtsFileName}.tts`, contents: this.newTtsFileContent };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/UploadTextFile`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('uploadFileSuccess')
                    this.loadData();
                    this.uploadFiles = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('uploadFileError')
                }
            })();
        },
        uploadFile() {
            this.uploadStatus = true;
            (async () => {
                let formData = new FormData();
                formData.append("token", sessionStorage.token);
                formData.append("upload", this.file);
                formData.append("path", `${this.$route.query.path}`);
                formData.append("convertAudio", 1);
                let config = { onUploadProgress: function (progressEvent) { this.uploadProgress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)); }.bind(this) };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/UploadFile`, formData, config, { headers: { "Content-Type": "multipart/form-data", } });
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('uploadFileSuccess')
                    this.loadData();
                    this.uploadFiles = false;
                    this.uploadStatus = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('uploadFileError')
                    this.uploadStatus = false;
                }
            })();
        },
        raname(item) {
            this.ranameDialog = true;
            this.ranameOld = item.name;
        },
        ranameSave() {
            (async () => {
                if (this.ranameOld.includes('wav')) this.ranameNew = this.ranameNew + '.wav'
                const body = { token: sessionStorage.token, action: "move", what: `${this.$route.query.path}/${this.ranameOld}`, target: `${this.$route.query.path}/${this.ranameNew}` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('ranameSucess')
                    this.loadData();
                    this.ranameNew = '',
                        this.ranameOld = '',
                        this.ranameDialog = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('ranameError')
                }
            })();
        },
        copy(item) {
            this.copyAlert = true;
            this.pathToCopy = item.what;
        },
        pasteCopy() {
            (async () => {
                const body = { token: sessionStorage.token, action: "copy", what: this.pathToCopy, target: this.$route.query.path };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('copyFileSuccess')
                    this.loadData();
                    this.pathToCopy = '',
                        this.copyAlert = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('copyFileError')
                }
            })();
        },
        move(item) {
            this.moveAlert = true;
            this.pathToMove = item.what;
        },
        pasteMove() {
            (async () => {
                const body = { token: sessionStorage.token, action: "move", what: this.pathToMove, target: this.$route.query.path };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('moveFileSuccess')
                    this.loadData();
                    this.pathToMove = '',
                        this.moveAlert = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('moveFileError')
                }
            })();
        },
        uploadMsg(item) {
            this.messageToUpload = item.name.replace('.wav', '');
            this.messageBodyToUpload = item.message;
            this.uploadMsgDialog = true;
        },
        uploadMsgFile() {
            (async () => {
                this.uploadStatus = true;
                let data = new FormData();
                data.append("token", sessionStorage.token);
                data.append("upload", this.msgFile);
                data.append("path", `${this.$route.query.path}/${this.messageToUpload}.wav`);
                data.append("convertAudio", 1);
                let config = { onUploadProgress: function (progressEvent) { this.uploadProgress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)); }.bind(this) };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/UploadFile`, data, config, { headers: { "Content-Type": "multipart/form-data", } });
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('uploadMessageSuccess')
                    this.loadData();
                    this.loadMsg();
                    this.uploadMsgDialog = false;
                    this.uploadStatus = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('uploadMessageError')
                    this.uploadStatus = false;
                }
            })();
        },
        download(item) {
            (async () => {
                const body = { token: sessionStorage.token, path: item.what };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/DownloadFile`, body);
                if (response.status == 200) {
                    location.href = `https://${sessionStorage.server}.call2all.co.il/ym/api/DownloadFile?token=${sessionStorage.token}&path=${item.what}`
                } else if (response.status == 404) {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('fileNotFoundDownload')
                }
            })();
        },
        stopAudio() {
            document.getElementById('audio').pause()
        },
        show(item, row) {
            // e.preventDefault()
            this.itemToAction = row.item
            this.showMenu = false
            this.x = item.x
            this.y = item.y
            this.$nextTick(() => {
                this.showMenu = true
            })
        },
        async multiCut() {
            for (let file of this.selectedFiles) {
                const body = { token: sessionStorage.token, action: "move", what0: file.what, target: this.$route.query.path };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('moveFileSuccess')
                    this.loadData();
                    this.multiCutAlert = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('moveFileError')
                }
            }
            this.selectedFiles = []
        },
        async multiCopy() {
            for (let file of this.selectedFiles) {
                const body = { token: sessionStorage.token, action: "copy", what0: file.what, target: this.$route.query.path };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('copyFileSuccess')
                    this.loadData();
                    this.multiCopyAlert = false;
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('copyFileError')
                }
            }
            this.selectedFiles = []
        },
        multiDownload() {
            for (let file of this.selectedFiles) {
                window.open(`https://www.call2all.co.il/ym/api/DownloadFile?token=${sessionStorage.token}&path=${file.what}`, "_blank")
            }
            this.selectedFiles = []
        },
        async multiDelete() {
            for (let file of this.selectedFiles) {
                const body = { token: sessionStorage.token, action: "delete", what: file.what };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/FileAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('fileDeleteSuccess')
                    this.loadData();
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('fileDeleteError')
                }
            }
            this.selectedFiles = []
        },
        goToExt(index) {
            if (index == 0) {
                this.$router.push({ path: 'ivr', query: { path: 'ivr2:/' } })
                this.loadData();
                this.loadMsg();
                this.loadSettings();
            } else if (index > 0) {
                let path
                for (let i = 0; i <= index; i++) {
                    console.log()
                    path += this.location[i] + '/'
                }
                path = path.replace('undefined', '').replace('ivr2/', 'ivr2:/').slice(0, -1)
                this.$router.push({ path: 'ivr', query: { path: path } })
                this.loadData();
                this.loadMsg();
                this.loadSettings();
            }
        },
        onCodeInput() {
            const cursorIndex = this.$refs.codeEditor.selectionStart;
            const lines = this.fileTextContent.substring(0, cursorIndex).split('\n');
            const currentLineIndex = lines.length - 1;
            const currentLine = lines[currentLineIndex];
            const lastTypedWord = currentLine.split(' ').pop();

            if (lastTypedWord !== '') {
                this.suggestions = this.keys.filter(key => key.key.startsWith(lastTypedWord));
                this.showSuggestions = this.suggestions.length > 0;
            } else {
                this.suggestions = [];
                this.showSuggestions = false;
            }
        },
        onSuggestionClick(suggestion) {
            if (suggestion.options) {
                const option = window.prompt(`בחר אפשרות: ${suggestion.options.join(', ')}`);
                if (option) {
                    this.$refs.codeEditor.focus();
                    const selectedSuggestion = `${suggestion.key}${option}`;
                    const cursorIndex = this.$refs.codeEditor.selectionStart;
                    const lines = this.fileTextContent.substring(0, cursorIndex).split('\n');
                    const currentLineIndex = lines.length - 1;
                    const currentLine = lines[currentLineIndex];
                    const lastTypedWord = currentLine.split(' ').pop();
                    this.fileTextContent = this.fileTextContent.replace(lastTypedWord, selectedSuggestion);
                    lines[currentLineIndex] = currentLine.replace(lastTypedWord, selectedSuggestion);
                    this.fileTextContent = lines.join('\n');
                }
            } else {
                this.showSuggestions = false;
                const cursorIndex = this.$refs.codeEditor.selectionStart;
                const lines = this.fileTextContent.substring(0, cursorIndex).split('\n');
                const currentLineIndex = lines.length - 1;
                const currentLine = lines[currentLineIndex];
                const lastTypedWord = currentLine.split(' ').pop();
                this.fileTextContent = this.fileTextContent.replace(lastTypedWord, suggestion.key);
                this.$refs.codeEditor.focus();
                lines[currentLineIndex] = currentLine.replace(lastTypedWord, suggestion.key);
                this.fileTextContent = lines.join('\n');
            }
        },
        onTabKeyDown(event) {
            event.preventDefault();
            if (this.showSuggestions) {
                this.onSuggestionClick(this.suggestions[0]);
            }
        }
    },
    beforeMount() {
        (async () => {
            const checkPerms = await axios.get('/api/users/getPerms', { headers: { 'Authorization': `Bearer ${sessionStorage.uToken}` } });
            if (checkPerms.config.headers.Authorization == 'Bearer undefined') {
                this.loadData();
                this.loadMsg();
                this.loadStatistics();
                this.loadSettings()
            }
            else {
                if (checkPerms.data.users[0].extnetions.includes(this.$route.query.path) || checkPerms.data.users[0].admin == "1") {
                    await this.loadData();
                    this.loadMsg();
                    this.loadStatistics();
                    this.loadSettings()
                }
                else {
                    this.$router.go(-1)
                    this.alert = true;
                    this.alertType = "warning";
                    this.alertContent = this.$t('accessForbiddenToExt')
                }
            }
        })();
        addEventListener('popstate', (event) => { console.log(event); this.loadData() });
        addEventListener('popstate', (event) => { console.log(event); this.loadMsg() });
        addEventListener('popstate', (event) => { console.log(event); this.loadStatistics() });
        addEventListener('popstate', (event) => { console.log(event); this.loadSettings() });
        this.loadData();
        this.loadMsg();
        this.loadStatistics();
        this.loadSettings()
    }
}
</script>
<style>
tr {
    cursor: pointer !important;
}

.CodeMirror {
    border-radius: 4px;
    padding: 10px 12px;
    font-family: 'Heebo', sans-serif;
    letter-spacing: normal !important;
    font-weight: 400 !important;
    line-height: 1.375rem !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%) !important;
}
</style>
<style>
textarea:focus {
    color: white !important;
}

.suggestions {
    position: absolute;
    z-index: 1;
    background-color: white;
    border: 1px solid #ccc;
    padding: 8px;
    max-height: 200px;
    overflow-y: auto;
}

.suggestions ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.suggestions ul li {
    cursor: pointer;
    padding: 5px;
}

.suggestions ul li:hover {
    background-color: #f5f5f5;
}
</style>